import StudentDashboard from "../components/Views/Student/Dashboard.vue";

import LecturerDashboard from "../components/Views/Lecturer/Home/Dashboard.vue";

import StaffDashboard from "../components/Views/SupportStaff/Home/Dashboard.vue";

//department's components
import DepartmentDashboard from "../components/Views/Department/Dashboard.vue";

//faculty components
import FacultyDashboard from "../components/Views/Faculty/Dashboard.vue";

//Faculty Officer components
import AdministrativeOfficerDashboard from "../components/Views/AdministrativeOfficer/Dashboard.vue";

//Faculty Officer components
import FinanceOfficerDashboard from "../components/Views/FinanceOfficer/Dashboard.vue";

//Hostel Manager components
import HostelManagerDashboard from "../components/Views/HostelManager/Dashboard.vue";

//academic level adviser's components
import AdviserDashboard from "../components/Views/AcademicLevelAdviser/Dashboard.vue";

//academic level adviser's components
import ExamOfficerDashboard from "../components/Views/Department/ExamOffice/Dashboard.vue";

//faculty components
import FacultyExamOfficerDashboard from "../components/Views/Faculty/ExamOffice/Dashboard.vue";

//director's components
import DirectorDashboard from "../components/Views/Director/Dashboard.vue";

//department's components
import CordinatorDashboard from "../components/Views/Cordinator/Dashboard.vue";

import ProgrammeCordinatorDashboard from "../components/Views/ProgrammeCordinator/Dashboard.vue";

//Super Admin components


// import LecturerDashboard from "../components/Views/Lecturer/Home/Dashboard.vue";

// import StaffDashboard from "../components/Views/SupportStaff/Home/Dashboard.vue";



import Enroll from '../components/Views/Enrollment/EnrollmentMultistepForm.vue';

// import Enroll from "../components/Views/Enrollment/EnrollmentMultistepForm.vue";

//-- email verification components
// import VerifyEmail from '../components/Views/EmailVerification/VerifyEmail.vue';

import Vue from 'vue';
import VueRouter from 'vue-router';
import AuthUser from '../apis/AuthUser';
import UserAPI from '../apis/User';
import { name } from "@chenfengyuan/vue-countdown";

Vue.use(VueRouter);

const routes = [
    {
    path: '/',
    // redirect: '/login'
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../components/Home.vue'),
    meta: { guestUserOnly: true }
},

{
    path: '/verify/:transaction_reference',
    // redirect: '/login'
    name: 'VerifyReceipt',
    component: () => import(/* webpackChunkName: "home" */ '../components/VerifyReceipt.vue'),
    meta: { guestUserOnly: true }
},

{
    path: '/verify/invoice/:transaction_reference',
    // redirect: '/login'
    name: 'VerifyInvoiceReceipt',
    component: () => import(/* webpackChunkName: "home" */ '../components/VerifyInvoiceReceipt.vue'),
    meta: { guestUserOnly: true }
},

{
    path: '/verify-admission-letter/:registration_number',
    // redirect: '/login'
    name: 'VerifyAdmissionLetter',
    component: () => import(/* webpackChunkName: "home" */ '../components/VerifyAdmissionLetter.vue'),
    meta: { guestUserOnly: true }
},

{
    path: '/change-password',
    name: 'Change Password',
    meta: { authenticatedUserOnly: true },
    component: () => import(/* webpackChunkName: "change-password" */ '../components/ChangePassword.vue'),
},

{
    path: "/login",
    redirect: '/',
    name: "Login",
    meta: { guestUserOnly: true },
},

{
    path: "/ssologin",
    name: "SSO Login",
    component: () =>
        import(/* webpackChunkName: "sso-login" */ "../components/SSOLogin"),
    meta: { guestUserOnly: true },
},

{
    path: "/candidate/login",
    name: "Candidate Login",
    redirect: "/pg/candidate/login",
},

{
    path: "/pg/candidate/login",
    name: "Postgraduate Candidate Login",
    component: () =>
        import(
                /* webpackChunkName: "local-login" */ "../components/LocalLogin"
        ),
    meta: { guestUserOnly: true },
},

{
    path: "/ug/candidate/:acronym?",
    name: "Undergraduate Candidate",
    component: () =>
        import(
                /* webpackChunkName: "ug-candidate-login" */ "../components/Views/Candidate/Undergraduate/UGPreadmissionLogin"
        ),
    meta: { guestUserOnly: true },
},

{
    path: '/ug/candidate/admission-processing-charges/confirm-payment-claim',
    name: 'Resolve Pre-Admission Fee Payment Claim',
    component: () => import(/* webpackChunkName: "ug-candidate-remita-confirm" */ '../components/Views/Candidate/Undergraduate/ConfirmRemitaPayment'),
    meta: { guestUserOnly: true }
},

{
    path: '/ug/applicant/admission-processing-charges/confirm-payment-claim',
    name: 'Resolve Applicant Pre-Admission Fee Payment Claim',
    component: () => import(/* webpackChunkName: "ug-applicant-remita-confirm" */ '../components/Views/Candidate/Undergraduate/PrivateInstitutions/ConfirmRemitaPayment'),
    meta: { guestUserOnly: true }
},

//post Graduate routes
{
    path: '/candidate/enroll',
    redirect: '/pg/candidate/enroll'
},

{
    path: '/pg/candidate/enroll',
    name: 'PG Enroll',
    component: () => import( /* webpackChunkName: "candidate-enrollment" */ '../components/Views/Pg/Enrollment/GetStarted'),
    meta: { guestUserOnly: true }
},
{
    path: '/candidate/referee/:candidateId/:identifier/:applicationId',
    name: 'Admission Referee',
    component: () => import( /* webpackChunkName: "admission-referee" */ '../components/Views/Pg/Enrollment/Referee'),
    meta: { guestUserOnly: true },
    props: true
},
{
    path: '/industry/siwes-evaluation/:evaluationId/:supervisor_identifier',
    name: 'Industry SIWES Evaluation',
    component: () => import( /* webpackChunkName: "industry-siwes-evaluation" */ '../components/Views/Lecturer/Siwes/IndustrySiwes'),
    meta: { guestUserOnly: true },
    props: true
},

// {
//     path: '/enroll',
//     name: 'Enroll',
//     component: Enroll,
//     meta: { guestUserOnly: true }
// },
// {
//     path: '/enrolled',
//     name: 'Enrolled',
//     component: () => import(/* webpackChunkName: "enroll-succuess" */ '../components/Views/Enrollment/EnrollmentAcknowledgement'),
//     meta: { guestUserOnly: true }
// },
{
    path: '/candidate/verify',
    name: 'Candidate Verification',
    component: () => import( /* webpackChunkName: "candidate-verification" */ '../components/Views/Admissions/CandidateVerification'),
    meta: { guestUserOnly: true }
},
// {
//     path: '/candidate/verification/complete',
//     name: 'Candidate Verification Complete',
//     component: () => import( /* webpackChunkName: "candidate-verification-complete" */ '../components/Views/Candidate/Undergraduate/VerificationComplete'),
//     meta: { guestUserOnly: true }
// },
{
    path: '/candidate/verification/complete',
    name: 'Candidate Verification Complete',
    component: () => import( /* webpackChunkName: "candidate-verification-complete" */ '../components/Views/Candidate/Undergraduate/VerificationComplete'),
    meta: { guestUserOnly: true }
},
{
    path: '/candidate/login/resent',
    name: 'Candidate Login Resent',
    component: () => import( /* webpackChunkName: "candidate-verification-complete" */ '../components/Views/Candidate/Undergraduate/PrivateInstitutions/LoginResent'),
    meta: { guestUserOnly: true }
},
{
    path: '/candidate/activate',
    name: 'Candidate Activation',
    component: () => import( /* webpackChunkName: "candidate-activation" */ '../components/Views/Admissions/CandidateActivation.vue'),
    meta: { guestUserOnly: true }
},

{
    path: '/candidate/below-general-cut-off',
    name: 'Below Minimum Cut-Off',
    component: () => import( /* webpackChunkName: "below-cutoff-mark" */ '../components/Views/Admissions/CandidateBelowInstitutionalCutOffMark.vue'),
    props: true,
    meta: { guestUserOnly: true }
},

{
    path: '/candidate/no-suggested-programme',
    name: 'No Suggested Programme',
    component: () => import( /* webpackChunkName: "no-suggested-programme" */ '../components/Views/Admissions/CandidateNoSuggestedProgramme.vue'),
    props: true,
    meta: { guestUserOnly: true }
},

{
    path: '/candidate/change-of-course',
    name: 'Change of Course',
    component: () => import( /* webpackChunkName: "change-course" */ '../components/Views/Admissions/ChangeOfCourse'),
    props: true,
    meta: { guestUserOnly: true }
},

{
    path: '/candidate/activated',
    name: 'Candidate Activated',
    component: () => import( /* webpackChunkName: "candidate-activated" */ '../components/Views/Admissions/CandidateAccountActivated'),
    props: true,
    meta: { guestUserOnly: true }
},
{
    path: '/no-access',
    name: 'AccessDenied',
    component: () => import(/* webpackChunkName: "unauthorized" */ '../components/UnAuthorized'),
    meta: { authenticatedUserOnly: true }
},
{
    path: "/make-payment",
    name: "Payment Template",
    component: () =>
        import(
            /* webpackChunkName: 'make-payment' */ "../components/Payment/PaymentComponents.vue"
        ),
    props: true,
    mode: "params",
},
{
    path: "/make-invoice-payment",
    name: "Invoice Payment Template",
    component: () =>
        import(
            /* webpackChunkName: 'make-invoice-payment' */ "../components/Payment/InvoicePaymentComponents.vue"
        ),
    props: true,
    mode: "params",
},
{
    path: "/callback/platinum",
    name: "Platinum Callback",
    component: () =>
        import(
            /* webpackChunkName: 'platinum-callback.js' */ "../components/Payment/PlatinumPaymentCallback.vue"
        ),
    props: true,
    mode: "params",
},
{
    path: '/student',
    name: 'Student', //route name modified Home -> Student
    component: StudentDashboard,
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkStudentRole,
    children: [{
        path: 'lectures',
        name: 'Lectures',
        component: () => import(/* webpackChunkName: 'student-lectures' */ '../components/Views/Student/Lectures.vue'),
    },
    {
        path: 'profile',
        component: () => import(/* webpackChunkName: 'student-profile' */ '../components/Views/Student/StudentProfile'),
        name: "Student Profile",
        props: true
    },
    // {
    //     path: 'courses',
    //     name: 'Courses',
    //     component: () => import(/* webpackChunkName: 'student-courses' */ '../components/Views/Student/Courses.vue'),
    // },
    {
        path: 'course-materials/:course_id',
        name: 'Course Naterials',
        component: () => import(/* webpackChunkName: 'course-materials' */ '../components/Views/Student/CourseMaterials'),
    },
    {
        path: 'rate-lecturer',
        name: "Rate Lecturer",
        component: () => import(/* webpackChunkName: 'rate-lecturer' */ '../components/Views/Student/RateLecturer'),
    },

    {
        path: 'inspired',
        name: 'My Inspired',
        component: () => import(/* webpackChunkName: 'student-inspired' */ '../components/Views/MyInspired/index'),
    },

    {
        path: 'course-registrations',
        name: 'My Course Registrations',
        component: () => import(/* webpackChunkName: 'student-course-reg' */ '../components/Views/Student/CourseRegistration'),
    },

    {
        path: 'siwes',
        name: 'My SIWES',
        component: () => import(/* webpackChunkName: 'student-siwes' */ '../components/Views/Student/Siwes/SiwesPlacementHome'),
        children: [
            {
                path: '',
                name: 'My Siwes Courses',
                component: () => import(/* webpackChunkName: 'student-siwes-courses' */ '../components/Views/Student/Siwes/SiwesPlacement'),
            },
            {
                path: 'placements',
                name: 'My Siwes Placements',
                component: () => import(/* webpackChunkName: 'student-siwes-placement' */ '../components/Views/Student/Siwes/SiwesPlacementLists'),
            },
        ],
    },

    {
        path: 'announcements',
        name: 'Student Announcements',
        component: () => import(/* webpackChunkName: 'student-announcement' */ '../components/Views/Student/Announcements'),
    },

    {
        path: 'transfer-requests',
        name: 'Student Transfer Requsts',
        component: () => import(/* webpackChunkName: 'student-announcement' */ '../components/Views/Student/Transfers.vue'),
    },

    {
        path: 'my-results',
        name: 'My Results',
        component: () => import(/* webpackChunkName: 'student-results' */ '../components/Views/Student/Results'),
    },

    {
        path: 'my-assignments',
        name: 'My Assignments',
        component: () => import(/* webpackChunkName: 'student-assignment' */ '../components/Views/Student/Assignments'),
    },
    {
        path: 'announcements',
        name: 'Announcements',
        component: () => import(/* webpackChunkName: 'student-announcement' */ '../components/Views/Student/Announcements'),
    },

    {
        path: "fees",
        component: () => import(/* webpackChunkName: 'student-fees-and-receipts' */ '../components/Views/Student/FeesAndReceiptsPrintOuts/FeesAndreceiptsHome'),
        children: [
            {
                path: "",
                name: 'Student Fees',
                component: () => import(/* webpackChunkName: 'student-fees' */ '../components/Views/Student/FeesAndReceiptsPrintOuts/SessionalRegistrationFees.vue'),
            },
            // {
            //     path: "portal-access-fees",
            //     name: 'Portal Access Fees',
            //     component: () => import(/* webpackChunkName: 'student-fees' */ '../components/Views/Student/FeesAndReceiptsPrintOuts/PortalAccessFees.vue'),
            // },
            {
                path: 'supplementary-fees',
                name: 'Student Supplementary Fees',
                component: () => import(/* webpackChunkName: 'supplementary-fees' */ '../components/Views/Student/FeesAndReceiptsPrintOuts/SupplementaryFees.vue'),
            },
            {
                path: 'receipts-and-printouts',
                name: 'Student PrintOut',
                component: () => import(/* webpackChunkName: 'student-receipts' */ '../components/Views/Student/FeesAndReceiptsPrintOuts/PrintOut.vue'),
            },
        ]
    },

    // {
    //     path: 'supplementary-fee',
    //     name: 'Student Supplementary Fees',
    //     component: () => import(/* webpackChunkName: 'student-supplementary-fee' */ '../components/Views/Student/SupplementaryFees'),
    // },



    {
        path: "hostel-booking",
        component: () => import(/* webpackChunkName: 'bedspace-reservations' */ '../components/Views/Student/HostelBooking/BedspacesAndReservations'),
        children: [{
            path: "",
            name: 'Available Hostels',
            component: () => import(/* webpackChunkName: 'available-hostels' */ '../components/Views/Student/HostelBooking/AvailableHostels'),
        },
        {
            path: 'my-reservation',
            name: 'MyReservation',
            component: () => import(/* webpackChunkName: 'my-reservations' */ '../components/Views/Student/HostelBooking/MyReservations'),
        },
        ]
    },
    {
        path: 'assignment-info',
        name: 'Assignment-Info',
        component: () => import(/* webpackChunkName: 'student-assigment-info' */ '../components/AssignmentInfo'),
    },
    {
        path: 'cbt',
        component: () => import(/* webpackChunkName: 'student-cbt' */ '../components/Views/Student/CBT/Home'),
        children: [{
            path: '',
            component: () => import(/* webpackChunkName: 'student-cbt-overview' */ '../components/Views/Student/CBT/Overview'),
            name: "Student CBT"
        },
        {
            path: 'test/:name',
            component: () => import(/* webpackChunkName: 'student-test-attempt' */ '../components/Views/Student/CBT/TestAttempt'),
            props: true
        }
        ]
    },
    {
        path: 'student-time-table',
        component: () => import(/* webpackChunkName: 'student-timetable' */ '../components/Views/Student/Schedules/MyTimeTable.vue'),
        name: 'Student Time Table'
    },
    {
        path: 'settings',
        component: () => import(/* webpackChunkName: 'student-settings' */ '../components/Settings'),
        name: "Settings"
    },
    {
        path: 'course',
        component: () => import( /* webpackChunkName: "course-home" */ '../components/Views/Student/Course/CourseManagement'),
        children: [

            {
                path: "",
                name: 'My Course Registration',
                component: () => import(/* webpackChunkName: 'student-course-reg' */ '../components/Views/Student/Course/CourseRegistration'),
            },
            {
                path: "course-form",
                name: 'My Course Form',
                component: () => import(/* webpackChunkName: 'student-course-form' */ '../components/Views/Student/Course/CourseForm.vue'),
            },
            {
                path: "extra-credit-applications",
                name: 'Student Extra Credit Applications',
                component: () => import(/* webpackChunkName: 'student-extra-credit-applications' */ '../components/Views/Student/Course/ExtraCreditApplications'),
            },
            {
                path: "add-and-drop",
                name: 'My Add and Drop',
                component: () => import(/* webpackChunkName: 'add-and-drop' */ '../components/Views/Student/Course/AddAndDrop'),
            },
        ]
    },

    {
        path: 'transaction-validation',
        name: 'Transactions Validation',
        component: () => import(/* webpackChunkName: 'transaction-validation' */ '../components/Views/Student/ValidateTransactions.vue'),
    },

    {
        path: "convocation-fees",
        name: 'Convocation Fees',
        component: () => import(/* webpackChunkName: 'convocation-fees' */ '../components/Views/Student/ConvocationFees'),
    },

    {
        path: "transcript",
        name: 'Student Transcript',
        component: () => import(/* webpackChunkName: 'convocation-fees' */ '../components/Views/Student/StudentTranscript'),
    },

    {
        path: "clearance",
        name: 'Student Clearance Management',
        component: () => import(/* webpackChunkName: 'clearance' */ '../components/Views/Student/ClearanceManagement'),
    },

    {
        path: "on-demand-clearance",
        name: 'Student On Demand Clearance',
        component: () => import(/* webpackChunkName: 'on-demand-clearance' */ '../components/Views/Student/OnDemandClearance'),
    },

    {
        path: 'invoices',
        name: 'Student Invoices',
        component: () => import(/* webpackChunkName: 'invoices' */ '../components/Views/Student/Invoice/ValidateInvoice'),
    },

    {
        path: 'course-materials/:course_id',
        name: 'Student Course Naterials',
        component: () => import(/* webpackChunkName: 'course-materials' */ '../components/Views/Student/CourseMaterials'),
    },
    {
        path: 'elections',
        name: 'Student Elections',
        component: () => import(/* webpackChunkName: 'student-elections' */ '../components/Views/Student/Evoting/EligibleElections'),
    },
    {
        path: 'elections/:uuid/vote',
        name: 'Student Elections Vote',
        component: () => import(/* webpackChunkName: 'student-elections-vote' */ '../components/Views/Student/Evoting/Vote'),
        //props: true,
    },
    {
        path: 'tickets',
        name: 'Student Ticketing',
        component: () => import(/* webpackChunkName: 'student-ticketing-vote' */ '../components/Views/Student/Ticketing/StudentsTickets'),
    },
    ],
},
// {
//     path: 'student/course-materials/:course_id',
//     name: 'Student Course Naterials',
//     component: () => import(/* webpackChunkName: 'course-materials' */ '../components/Views/Student/CourseMaterials'),
// },
{
    path: '/lecturer',
    name: 'Lecturer', //route name modified Home -> Lecturer
    component: LecturerDashboard,
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkLecturerRole,
    children: [{
        path: 'lecturer-assignments/:course_id',
        name: 'Assignments',
        component: () => import(/* webpackChunkName: 'lecturer-assignement' */ '../components/Views/Lecturer/Assignments')
    },
    {
        path: 'my-courses/course-info/:courseAllocationID',
        name: 'Course Info',
        component: () => import(/* webpackChunkName: 'lecturer-course-info' */ '../components/Views/Lecturer/CourseInfo'),
        props: true
    },

    {
        path: 'add-assessment/:course_id/:session_id/:semester_id',
        component: () => import(/* webpackChunkName: 'add-assessment' */ '../components/Views/Lecturer/AddAssessment'),
        name: "Add New Assessment"
    },

    {
        path: 'my-courses/course-info/:courseId/synopsis/:courseAllocationID/:sessionId',
        name: 'Course Synopsis',
        component: () => import(/* webpackChunkName: 'lecturer-course-synopsis' */ '../components/Views/Lecturer/CourseSynopsis'),
        props: true
    },
    {
        path: 'assignment-info/:assignment_id',
        name: 'Assignment Info',
        component: () => import(/* webpackChunkName: 'lecturer-assigment-info' */ '../components/AssignmentInfo'),
    },
    {
        path: 'submitted-assignment',
        name: 'Submitted Assignments',
        component: () => import(/* webpackChunkName: 'lecturer-submitted-assignment' */ '../components/Views/Lecturer/SubmittedAssignment'),
    },
    {
        path: 'my-courses',
        name: 'My Courses',
        component: () => import(/* webpackChunkName: 'lecturer-courses' */ '../components/Views/Lecturer/MyCourses'),
    },

    {
        path: 'announcements',
        name: 'Lecturer Announcements',
        component: () => import(/* webpackChunkName: 'student-announcement' */ '../components/Views/Lecturer/Announcements'),
    },

    {
        path: 'inspired',
        name: 'Access My Inspired',
        component: () => import(/* webpackChunkName: 'lecturer-inspired' */ '../components/Views/MyInspired/index'),
    },
    {
        path: 'support',
        component: () => import(/* webpackChunkName: "lecturer-support" */ '../components/Views/Lecturer/Support.vue'),
        name: "Lecturer Support",
        props: true
    },
    {
        path: 'elections',
        name: 'Lecturer Elections',
        component: () => import(/* webpackChunkName: 'lecturer-elections' */ '../components/Views/Lecturer/Evoting/EligibleElections.vue'),
    },
    {
        path: 'elections/:uuid/vote',
        name: 'Lecturer Elections Vote',
        component: () => import(/* webpackChunkName: 'lecturer-elections-vote' */ '../components/Views/Lecturer/Evoting/Vote'),
        //props: true,
    },

    {
        path: 'profile',
        component: () => import(/* webpackChunkName: 'lecturer-profile' */ '../components/Views/Lecturer/LecturerProfile'),
        name: "Lecturer Profile",
        props: true
    },
    {
        path: 'add-assignment/:course_id',
        component: () => import(/* webpackChunkName: 'lecturer-add-assignment' */ '../components/Views/Lecturer/AddAssignment'),
        name: "Add Assignment"
    },
    {
        path: 'add-assessment/:course_id/:session_id/:semester_id',
        component: () => import(/* webpackChunkName: 'lecturer-add-assessment' */ '../components/Views/Lecturer/AddAssessment'),
        name: "Add Assessment"
    },

    {
        path: 'lectures-list',
        component: () => import(/* webpackChunkName: 'lectures-list' */ '../components/Views/Lecturer/LecturesList'),
        name: 'Lecturer Lectures'
    },
    {
        path: 'lecture-meet/:mid',
        props: true,
        component: () => import(/* webpackChunkName: 'lectures-meet' */ '../components/Views/VirtualClass/LectureMeet'),
        name: 'LectureMeet'
    },
    {
        path: 'cbt',
        component: () => import(/* webpackChunkName: 'lecturer-cbt-home' */ '../components/Views/Lecturer/CBT/Home'),
        children: [{
            path: '',
            component: () => import(/* webpackChunkName: 'lecturer-cbt-list' */ '../components/Views/Lecturer/CBT/List'),
            name: "CBT",
        },
        {
            path: 'add',
            component: () => import(/* webpackChunkName: 'lecturer-cbt-add' */ '../components/Views/Lecturer/CBT/Add'),
            name: "Create CBT",
        },
        {
            path: 'questions',
            component: () => import(/* webpackChunkName: 'lecturer-cbt-questions' */ '../components/Views/Lecturer/CBT/Questions'),
            name: "CBT Questions",
        }
        ]
    },
    {
        path: 'time-table',
        component: () => import(/* webpackChunkName: 'lecturer-timetable' */ '../components/Views/Lecturer/Schedules/MyTimeTable'),
        name: 'Lecturer Time Table'
    },
    {
        path: 'tickets',
        name: 'Lecturer Ticketing',
        component: () => import(/* webpackChunkName: 'student-elections-vote' */ '../components/Views/Lecturer/Ticketing/LecturerTickets'),
    },
    {
        path: "learned-conferences",
        component: () =>
            import(
                /* webpackChunkName: 'lecturer-learned-conferences' */ "../components/Views/Lecturer/LearnedConference/LearnedConferenceHome.vue"
            ),
        children: [
            {
                path: "",
                name: "Learned Conferences",
                component: () =>
                    import(
                        /* webpackChunkName: 'lecturer-learned-conference' */ "../components/Views/Lecturer/LearnedConference/LearnedConference.vue"
                    ),
            },
            {
                path: "all",
                name: "Learned Conference Applications",
                component: () =>
                    import(
                        /* webpackChunkName: 'lecturer-learned-conference-list' */ "../components/Views/Lecturer/LearnedConference/LearnedConferenceApplicationList.vue"
                    ),
                props: true,
            },
            {
                path: "application",
                name: "Learned Conference Application",
                component: () =>
                    import(
                        /* webpackChunkName: 'lecturer-learned-conference-application' */ "../components/Views/Lecturer/LearnedConference/LearnedConferenceApplication.vue"
                    ),
                props: true,
            },
        ],
    },
    {
        path: 'siwes',
        name: 'Lecturer SIWES',
        component: () => import(/* webpackChunkName: 'lecturer-siwes' */ '../components/Views/Lecturer/Siwes/Siwes'),
    },
    ]
},

{
    path: '/staff',
    name: 'Staff', //route name modified Home -> staff
    component: StaffDashboard,
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkStaffRole,
    children: [
    {
        path: 'announcements',
        name: 'Support Staff Announcements',
        component: () => import(/* webpackChunkName: 'support-staff-announcement' */ '../components/Views/SupportStaff/Announcements'),
    },

    {
        path: 'support',
        component: () => import(/* webpackChunkName: "support-staff-support" */ '../components/Views/SupportStaff/Support.vue'),
        name: "Support Staff Support",
        props: true
    },

    {
        path: 'profile',
        component: () => import(/* webpackChunkName: 'support-staff-profile' */ '../components/Views/SupportStaff/Profile'),
        name: "Support Staff Support Profile",
        props: true
        },
        {
            path: 'elections',
            name: 'Support Staff Elections',
            component: () => import(/* webpackChunkName: 'support-staff-elections' */ '../components/Views/SupportStaff/Evoting/EligibleElections.vue'),
        },
        {
            path: 'elections/:uuid/vote',
            name: 'Support Staff Elections Vote',
            component: () => import(/* webpackChunkName: 'support-staff-elections-vote' */ '../components/Views/SupportStaff/Evoting/Vote.vue'),
            //props: true,
        },

    ]
},

//routings to the Institution Super Admin sections
{
    path: '/admin',
    component: () => import(/* webpackChunkName: "admin-dashboard" */ '../components/Views/Admin/AdminDashboard.vue'),
    name: 'Admin',
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkSuperAdminRole,
    children: [{
        path: 'overview',
        component: () => import(/* webpackChunkName: "admin-overview" */ '../components/Views/Admin/AdminOverview.vue'),
        name: 'Administrator Home',
    },
    {
        path: "institutes",
        name: "Institutes",
        component: () =>
            import(
                /* webpackChunkName: 'institutes-home' */ "../components/Views/Institutes/Overview.vue"
            ),
    },
    {
        path: "graduating-list",
        name: "Graduating List",
        component: () =>
            import(
                /* webpackChunkName: 'graduating-list' */ "../components/Views/Admin/GraduatingList/GraduatingList.vue"
            ),
    },
    {
        path: 'user-profile/:user',
        component: () => import(/* webpackChunkName: "super-admin-profile" */ '../components/Views/Admin/Profiles/SuperAdminProfile.vue'),
        name: "Super Admin Profile",
        props: true
    },
    {
        path: 'institution/profile',
        component: () => import(/* webpackChunkName: "institution-profile" */ '../components/Views/Admin/Profiles/InstitutionProfile.vue'),
        name: "Institution Profile",
        props: true
    },

    {
        path: 'institution/support',
        component: () => import(/* webpackChunkName: "institution-support" */ '../components/Views/Admin/Support/Support.vue'),
        name: "Admin Support",
        props: true
    },

    {
        path: 'institution/themes',
        component: () => import(/* webpackChunkName: "institution-themes" */ '../components/Views/Admin/Themes/Themes.vue'),
        name: "Institution Theme",
        props: true
        },

        {
            path: 'institution',
            redirect: 'overview'  // Redirects to the 'overview' page, this is for the sake of breadcrumbs
        },

    // {
    //     path: 'users',
    //     component: () => import( /* webpackChunkName: "users-home" */ '../components/Views/Admin/Users/UsersManagement'),
    //     children: [{
    //         path: "",
    //         name: 'Manage Students',
    //         component: () => import( /* webpackChunkName: "users-students" */ '../components/Views/Admin/Users/StudentManagement')
    //     },
    //     {
    //         path: "lecturers",
    //         name: 'Manage Lecturers',
    //         component: () => import( /* webpackChunkName: "users-lecturers" */ '../components/Views/Admin/Users/LecturerManagement')
    //     },
    //     {
    //         path: "supporting-staff",
    //         name: 'Manage Supporting Staff',
    //         component: () => import( /* webpackChunkName: "users-supporting-staff" */ '../components/Views/Admin/Users/SupportStaffManagement'),
    //     },
    //     {
    //         path: "all-students",
    //         name: 'Manage All Institution Students',
    //         component: () => import( /* webpackChunkName: "all-students" */ '../components/Views/Admin/Users/AllStudentsManagement'),
    //     },
    //     {
    //         path: "students-data",
    //         name: 'Manage Active Institution Students Data',
    //         component: () => import( /* webpackChunkName: "students-data" */ '../components/Views/Admin/Users/StudentDataManagement'),
    //     },
    // ]
    // },

    {
        path: "learned-conferences",
        component: () =>
            import(
                /* webpackChunkName: 'admin-learned-conferences' */ "../components/Views/Admin/LearnedConference/LearnedConferenceHome"
            ),
        children: [
            {
                path: "",
                name: "Manage Learned Conference",
                component: () =>
                    import(
                        /* webpackChunkName: "admin-learned-conferences" */ "../components/Views/Admin/LearnedConference/LearnedConferences"
                    ),
            },
            {
                path: "all",
                name: "All Learned Conference Applications",
                component: () =>
                    import(
                        /* webpackChunkName: "all-learned-conferences-list" */ "../components/Views/Admin/LearnedConference/LearnedConferencesList"
                    ),
            },
        ],
    },

    // {
    //     path: "siwes",
    //     name: "Manage SIWES",
    //     component: () =>
    //         import(
    //             /* webpackChunkName: 'admin-siwes' */ "../components/Views/Admin/Siwes/SiwesHome"
    //         ),
    // },



    {
        path: "users/students/:id",
        name: 'Admin Student Profile',
        component: () => import( /* webpackChunkName: "users-student-profile" */ '../components/Views/Admin/Users/StudentProfile.vue'),
    },
    {
        path: "users/student-status/:id",
        name: 'Admin Student Status',
        component: () => import( /* webpackChunkName: "users-student-status" */ '../components/Views/Admin/Users/StudentStatus.vue'),
        props: true,
    },
    {
        path: "users/lecturers/:id",
        name: 'Admin Lecturer Profile',
        component: () => import( /* webpackChunkName: "users-lecturer-profile" */ '../components/Views/Admin/Users/LecturerProfile.vue'),
    },
    {
        path: "users/supporting-staff/:id",
        name: 'Support Staff Profile',
        component: () => import( /* webpackChunkName: "users-supporting-profile" */ '../components/Views/Admin/Users/LecturerProfile.vue'),
    },
    {
        path: 'sub-admins',
        component: () => import( /* webpackChunkName: "sub-admins" */ '../components/Views/Admin/RolesAndPermissions/SubAdmins'),
        name: 'Manage Sub Admins',
    },
    {
        path: 'clearance-management',
        component: () => import( /* webpackChunkName: "admin-clearance-management" */ '../components/Views/Admin/Clearance/ClearanceManagement'),
        children: [

            {
                path: "certificates",
                name: 'Clearance Certificates',
                component: () => import( /* webpackChunkName: "admin-clearance-certificates" */ '../components/Views/Admin/Clearance/ClearanceCertificates'),
            },
            {
                path: "student-clearance-list",
                name: 'Students Clearance List',
                component: () => import(/* webpackChunkName: 'admin-clearance-list' */ '../components/Views/Admin/Clearance/StudentClearanceList'),
            }
        ]
    },
    {
        path: 'clearance-lists',
        component: () => import( /* webpackChunkName: "clearance-lists" */ '../components/Views/Admin/Clearance/ClearanceLists'),
        name: 'Manage Student Clearance',
    },
    {
        path: 'on-demand-clearance',
        component: () => import( /* webpackChunkName: "on-demand-clearance" */ '../components/Views/Admin/Clearance/OnDemandClearanceManagement.vue'),
        children: [

            {
                path: "clearances",
                name: 'On-Demand Clearance',
                component: () => import( /* webpackChunkName: "on-demand-clearance-clearance" */ '../components/Views/Admin/Clearance/OnDemandClearance.vue'),
            },
            {
                path: "clearance-list",
                name: 'Clearance List',
                component: () => import(/* webpackChunkName: 'on-demand-clearance-list' */ '../components/Views/Admin/Clearance/OnDemandClearanceLists.vue'),
            }
        ]
    },
    {
        path: 'on-demand-clearance/details',
        name: "On-Demand Clearance Details",
        component: () => import( /* webpackChunkName: 'on-demand-clearance-details' */ '../components/Views/Admin/Clearance/OnDemandClearanceDetails'),
        props: true,
    },
    {
        path: 'on-demand-clearance/students',
        name: "On-Demand Clearance Students",
        component: () => import( /* webpackChunkName: 'on-demand-clearance-students' */ '../components/Views/Admin/Clearance/OnDemandClearanceStudents'),
        props: true,
    },
    {
        path: 'campuses',
        component: () => import( /* webpackChunkName: "manage-campuses" */ '../components/Views/Admin/Campuses/CampusAndStudyCenter'),
        children: [{
            path: "",
            name: 'Manage Campuses',
            component: () => import( /* webpackChunkName: "campus-lists" */ '../components/Views/Admin/Campuses/CampusList')
        },
        {
            path: "study-centres",
            name: 'Study Centres',
            component: () => import( /* webpackChunkName: "study-centre-list" */ '../components/Views/Admin/Campuses/StudyCenterList')
        },
        ]
    },
    {
        path: 'affiliations',
        component: () => import( /* webpackChunkName: "manage-affiliates" */ '../components/Views/Admin/Affiliations/Affiliation'),
        name: 'Manage Affiliations',
    },
    {
        path: "faculties",
        //name: 'Manage Faculties & Departments',
        component: () => import( /* webpackChunkName: "faculty-departments" */ '../components/Views/Admin/FacultiesAndDepartments/FacultiesAndDepartements'),
        //props: true,
        children: [{
            path: "",
            name: 'Manage Faculties',
            component: () => import( /* webpackChunkName: "faculty-lists" */ '../components/Views/Admin/FacultiesAndDepartments/FacultyList')
        },
        {
            path: "departments",
            name: 'Manage Departments',
            component: () => import( /* webpackChunkName: "department-list" */ '../components/Views/Admin/FacultiesAndDepartments/DepartmentList')
        },
        {
            path: "academic-units",
            name: 'Manage Academic Units',
            component: () => import( /* webpackChunkName: "academic-unit-list" */ '../components/Views/Admin/FacultiesAndDepartments/AcademicUnitList')
        },
        ]
    },

    {
        path: "directorates",
        component: () => import( /* webpackChunkName: "directorates-and-units" */ '../components/Views/Admin/Directorates/DirectoratesAndUnits'),
        children: [{
            path: "",
            name: 'Manage Centres and Directorates',
            component: () => import( /* webpackChunkName: "directorates-list" */ '../components/Views/Admin/Directorates/Directorates'),
        },
        {
            path: "service-units",
            name: 'Manage Service Units',
            component: () => import( /* webpackChunkName: "service-unit-list" */ '../components/Views/Admin/Directorates/ServiceUnits'),
        },
        ]
    },

    {
        path: "faculty/profile",
        name: "Faculty Profile",
        component: () =>
            import(
                /* webpackChunkName: "faculty-profile" */
                "../components/Views/Admin/FacultiesAndDepartments/FacultyProfile.vue"
            ),
        props: true,
    },

    {
        path: 'department/profile',
        name: 'Department Profile',
        component: () => import( /* webpackChunkName: "department-profile" */ '../components/Views/Admin/FacultiesAndDepartments/DepartmentProfile'),
        props: true,
    },

    {
        path: 'academic-unit/profile',
        name: 'Academic Unit Profile',
        component: () => import( /* webpackChunkName: "academic-unit-profile" */ '../components/Views/Admin/FacultiesAndDepartments/AcademicUnitProfile'),
        props: true,
    },

    {
        path: 'institute/profile',
        name: 'Institute Profile',
        component: () => import( /* webpackChunkName: "institute-profile" */ '../components/Views/Institutes/InstituteProfile'),
        props: true,
    },

    {
        path: 'programmes',
        // name: 'Manage Academic Programmes & Courses',
        component: () => import( /* webpackChunkName: "programmes-and-course-home" */ '../components/Views/Admin/ProgrammesAndCourses/ProgrammesAndCourses'),
        children: [{
            path: '',
            name: 'Manage Academic Programmes',
            component: () => import( /* webpackChunkName: "mainstream-academic-programmes" */ '../components/Views/Admin/ProgrammesAndCourses/ProgrammeList')
        },
        {
            path: "programme-specializations",
            name: 'Manage Programmes Specializations',
            component: () => import( /* webpackChunkName: "programme-specializations" */ '../components/Views/Admin/ProgrammesAndCourses/ProgrammeSpecializations')
        },
        {
            path: "affiliate-programmes",
            name: 'Manage Affiliate Academic Programmes',
            component: () => import( /* webpackChunkName: "affiliate-academic-programmes" */ '../components/Views/Admin/ProgrammesAndCourses/AffiliateProgrammeList')
        },
        ]
    },

    {
        path: 'courses',
        component: () => import( /* webpackChunkName: "courses-home" */ '../components/Views/Admin/Courses/CourseManagement'),
        children: [
            {
                path: "",
                name: 'Manage Courses',
                component: () => import( /* webpackChunkName: "managecourse-list" */ '../components/Views/Admin/Courses/CourseList')
            },

            {
                path: "course-specifications",
                name: 'Manage Course Specifications',
                component: () => import( /* webpackChunkName: "admin-manage-course-specs" */ '../components/Views/Admin/Courses/CourseSpecification')
            },

            {
                path: "credit-load-limit",
                name: 'Manage Credit Load Limit',
                component: () => import( /* webpackChunkName: "manage-credit-load-limit-list" */ '../components/Views/Admin/Courses/CreditLoadLimitList')
            },
        ]

    },

    {
        path: 'mode-of-study',
        component: () => import( /* webpackChunkName: "'mode-of-study-home" */ '../components/Views/Admin/ModeOfStudy/ModeOfStudy'),
        children: [
            {
                path: '',
                name: 'Manage Mode of Study',
                component: () => import( /* webpackChunkName: "mode-of-study" */ '../components/Views/Admin/ModeOfStudy/ModeOfStudyList')
            }
        ]
    },
    {
        path: 'matric-no-template',
        component: () => import( /* webpackChunkName: "matric-no-template-home" */ '../components/Views/Admin/MatricNumber/MatricNumberTemplate'),
        children: [{
            path: '',
            name: 'Manage Matric Template',
            component: () => import( /* webpackChunkName: "matric-template-list" */ '../components/Views/Admin/MatricNumber/MatricNumberTemplateList')
        },
        {
            path: 'generate-matric-no',
            name: 'Generate Matric Number',
            component: () => import( /* webpackChunkName: "generate-matric-no" */ '../components/Views/Admin/MatricNumber/GenerateMatricNumber')
        },
        {
            path: 'matric-number-buffer',
            name: 'Matric Number Buffer',
            component: () => import( /* webpackChunkName: "matric-number-buffer" */ '../components/Views/Admin/MatricNumber/MatricNumberExemptionList')
        },
        {
            path: 'matric-number-list',
            name: 'Matric Number List',
            component: () => import( /* webpackChunkName: "matric-number-list" */ '../components/Views/Admin/MatricNumber/MatriculatedList')
        },
        ]
    },
    {
        path: 'students-registration-list',
        component: () => import( /* webpackChunkName: "students-registration-list-home" */ '../components/Views/Admin/StudentsRegistrationList/StudentsRegistration'),
        children: [
            {
                path: '',
                name: 'Manage Students Registration',
                component: () => import( /* webpackChunkName: "students-registration-list" */ '../components/Views/Admin/StudentsRegistrationList/StudentsRegistrationList')
            },
            {
                path: 'submission-list',
                name: 'View Registration Submission List',
                component: () => import( /* webpackChunkName: "students-registration-submission-list" */ '../components/Views/Admin/StudentsRegistrationList/StudentsRegistrationSubmissionList')
            },
            {
                path: 'enrollment-list',
                name: 'View Course Enrollment List',
                component: () => import( /* webpackChunkName: "students-courses-enrollment-list" */ '../components/Views/Admin/StudentsRegistrationList/StudentsCoursesEnrollmentList')
            },
            {
                path: 'management',
                name: 'Course Registration Management',
                component: () => import( /* webpackChunkName: "students-courses-reg-management" */ '../components/Views/Admin/StudentsRegistrationList/StudentsCoursesRegistrationManagement'),
            },
        ]
    },
    {
        path: 'submission-list/information',
        name: "Student's Course Registration Information",
        component: () => import( /* webpackChunkName: 'admin-students-course-registration-information' */ '../components/Views/Admin/StudentsRegistrationList/StudentCourseRegistrationInformation'),
        props: true
    },
    {
        path: 'students-results-list',
        component: () => import( /* webpackChunkName: "manage-students-results-list" */ '../components/Views/Admin/StudentsResults/StudentsResultList'),
        name: 'Manage Student Results',
    },
    {
        path: 'admin-student-results',
        component: () => import( /* webpackChunkName: "admin-student-results" */ '../components/Views/Admin/StudentsResults/StudentResults'),
        name: 'Admin Student Results',
    },
    {
        path: 'academic_sessions',
        // name: 'Manage Sessions & Semseters',
        component: () => import( /* webpackChunkName: "semester-and-session-home" */ '../components/Views/Admin/SessionsAndSemesters/SessionsAndSemesters'),
        children: [{
            path: '',
            name: 'Manage Academic Sessions',
            component: () => import( /* webpackChunkName: "academic-sessions-list" */ '../components/Views/Admin/SessionsAndSemesters/AcademicSessions.vue'),
        },
        {
            path: "semesters",
            name: 'Manage Semesters',
            component: () => import( /* webpackChunkName: "semesters-list" */ '../components/Views/Admin/SessionsAndSemesters/Semesters'),
        },
        {
            path: 'session_semester_settings',
            name: 'Session & Semseter Configurations',
            component: () => import( /* webpackChunkName: "session-semester-setting" */ '../components/Views/Admin/SessionsAndSemesters/SessionAndSemesterSettings')
        },
        {
            path: "late-registrations",
            name: 'Manage Late Registrations',
            component: () => import( /* webpackChunkName: "late-registrations-list" */ '../components/Views/Admin/SessionsAndSemesters/LateRegistrations'),
        },
        {
            path: "late-registration-exemption-list",
            name: 'Manage Late Registration Exemption List',
            component: () => import( /* webpackChunkName: "late-registration-exemption-list" */ '../components/Views/Admin/SessionsAndSemesters/LateRegistrationExemptionList'),
        },
        {
            path: "special-sessions",
            name: 'Manage Special Sessions',
            component: () => import( /* webpackChunkName: "late-registrations-list" */ '../components/Views/Admin/SessionsAndSemesters/SpecialSessions'),
        },
        ]
    },

    {
        path: 'admin-announcement',
        component: () => import( /* webpackChunkName: "manage-announcement-list" */ '../components/Views/Admin/Announcements/AnnouncementsList'),
        name: 'Manage Announcement',
    },


    {
        path: 'ranks',
        // name: "Manage Ranks",
        component: () => import( /* webpackChunkName: "ranks-home" */ '../components/Views/Admin/Ranks/Ranks'),
        children: [{
            path: '',
            name: 'Manage Academic Ranks',
            component: () => import( /* webpackChunkName: "academic-ranks-list" */ '../components/Views/Admin/Ranks/AcademicRank')
        },
        {
            path: "non-academic-ranks",
            name: 'Manage Non-Academic Ranks',
            component: () => import( /* webpackChunkName: "non-academic-ranks-list" */ '../components/Views/Admin/Ranks/NonAcademicRank')
        },
        {
            path: "rank-cadres",
            name: 'Manage Rank Cadres',
            component: () => import( /* webpackChunkName: "rank-cadres-list" */ '../components/Views/Admin/Ranks/RankCadres')
        },
        ]
    },
    {
        path: 'degree-categories',
        name: "Manage Academic Degrees",
        component: () => import( /* webpackChunkName: "academic-degree-categories" */  '../components/Views/Admin/AcademicDegrees/AcademicDegreeCategory')
    },

    {
        path: 'academic-levels',
        // name: 'Students & Academic Programmes Levels',
        component: () => import( /* webpackChunkName: "academic-levels-home" */  '../components/Views/Admin/AcademicLevels/Levels'),
        children: [
            {
                path: "",
                name: 'Manage Academic Programme Levels',
                component: () => import( /* webpackChunkName: "program-academic-levels" */  '../components/Views/Admin/AcademicLevels/AcademicProgrammeLevels'),
            },
            {
                path: 'student-levels',
                name: 'Manage Students Academic Levels',
                component: () => import( /* webpackChunkName: "student-academic-levels" */  '../components/Views/Admin/AcademicLevels/StudentAcademicLevels')
            },
            {
                path: 'students-level-progression',
                name: 'Students Academic Level Progression',
                component: () => import( /* webpackChunkName: "student-level-progression" */  '../components/Views/Admin/AcademicLevels/StudentAcademicLevelProgression')
            },
        ]
    },

    {
        path: 'time-tables',
        // name: "Manage Time Tables",
        component: () => import( /* webpackChunkName: "time-tables-home" */  '../components/Views/Admin/TimeTables/TimeTablingHome'),
        children: [{
            path: '',
            name: 'Manage Time Tables',
            component: () => import( /* webpackChunkName: "time-table-list" */  '../components/Views/Admin/TimeTables/TimeTables'),
        },
        {
            path: "profiles",
            name: 'Manage TimeTable Profiles',
            component: () => import( /* webpackChunkName: "time-table-profiles-list" */  '../components/Views/Admin/TimeTables/TimeTableProfiles'),
        },
        {
            path: "lecture-venues",
            name: 'Manage Lecture Venues',
            component: () => import( /* webpackChunkName: "lecture-venues-list" */  '../components/Views/Admin/TimeTables/LectureVenues'),
        },
        ]
    },
    {
        path: "time-tables/editor",
        name: 'Edit Time Table',
        component: () => import( /* webpackChunkName: "time-table-editor" */  '../components/Views/Admin/TimeTables/TimeTableEditor'),
        props: true
    },
    {
        path: "time-table-activities/editor",
        name: 'Edit Time Table Activity',
        component: () => import( /* webpackChunkName: "time-table-activities-editor" */  '../components/Views/Admin/TimeTables/TimeTableActivityEditor'),
        props: true
    },
    {
        path: "roles",
        name: 'Manage Roles & Permissions',
        component: () => import( /* webpackChunkName: 'roles-permissions-home' */ '../components/Views/Admin/RolesAndPermissions/Roles'),
    },
    {
        path: 'transfer-requests',
        // name: 'Transfer Requests',
        component: () => import(/* webpackChunkName: 'admin-transfer-requests' */ '../components/Views/Admin/Transfers/TransferRequestHome'),
        children: [
            {
                path: '',
                name: 'Manage Transfer Requests',
                component: () => import( /* webpackChunkName: "admin-transfer-requests-list" */ '../components/Views/Admin/Transfers/TransferRequestApplication.vue'),
            },
            {
                path: 'all-requests',
                name: 'Manage Transfer Requests',
                component: () => import( /* webpackChunkName: "admin-transfer-requests-list" */ '../components/Views/Admin/Transfers/Home.vue'),
            },
            {
            path: "all",
            name: 'All Transfer Requests',
            component: () => import( /* webpackChunkName: "admin-transfer-request-all" */ '../components/Views/Admin/Transfers/All.vue'),
            },
            {
                path: "pending-release",
                name: 'Pending Release Transfer Requests',
                component: () => import( /* webpackChunkName: "admin-transfer-request-release" */ '../components/Views/Admin/Transfers/PendingRelease'),
            },
            {
                path: "pending-acceptance",
                name: 'Pending Acceptance Transfer Requests',
                component: () => import( /* webpackChunkName: "admin-transfer-request-acceptance" */ '../components/Views/Admin/Transfers/PendingAcceptance'),
            },
            {
                path: "pending-approval",
                name: 'Pending Approval Transfer Requests',
                component: () => import( /* webpackChunkName: "admin-transfer-request-approval" */ '../components/Views/Admin/Transfers/PendingApproval'),
            },

        ]
    },
    {
        path: 'candidate-recommendations',
        component: () => import(/* webpackChunkName: 'admin-candidate-recommendations' */ '../components/Views/Admin/CandidateRecommendation/CandidateRecommendationHome'),
        children: [
            {
                path: '',
                name: 'Manage Recommended Candidates',
                component: () => import( /* webpackChunkName: "admin-candidate-recommendations-list" */ '../components/Views/Admin/CandidateRecommendation/RecommendedCandidates.vue'),
            },
            {
                path: 'all-candidates',
                name: 'Manage All Candidate Recommendations',
                component: () => import( /* webpackChunkName: "admin-candidate-recommendations-list" */ '../components/Views/Admin/CandidateRecommendation/AllCandidates.vue'),
            },
        ]
    },

    // {
    //     path: "extra-credit-applications",
    //     name: 'Admin Extra Credit Applications',
    //     component: () => import(/* webpackChunkName: 'admin-extra-credit-applications' */ '../components/Views/Admin/ExtraCreditApplications/ExtraCreditApplications'),
    // },

    {
        path: 'extra-credit-applications',
        component: () => import(/* webpackChunkName: 'admin-extra-credit-applications' */ '../components/Views/Admin/ExtraCreditApplications/ExtraCreditApplicationHome'),
        children: [
            {
                path: '',
                name: 'Manage Extra Credit Applications',
                component: () => import( /* webpackChunkName: "admin-extra-credit-applications-list" */ '../components/Views/Admin/ExtraCreditApplications/ExtraCreditApplications'),
            },
            {
                path: 'all',
                name: 'All Extra Credit Applications',
                component: () => import( /* webpackChunkName: "all-extra-credit-applications-list" */ '../components/Views/Admin/ExtraCreditApplications/ExtraCreditApplicationsList'),
            },
        ]
    },

    {
        path: "scholarship-list",
        name: 'Admin Scholarship List',
        component: () => import(/* webpackChunkName: 'admin-scholarship-list' */ '../components/Views/Admin/Scholarship/ScholarshipList'),
    },

    {
        path: "role/grant-revoke-permissions",
        name: 'Grant & Revoke Permissions',
        component: () => import( /* webpackChunkName: 'grant-revoke permissions' */ '../components/Views/Admin/RolesAndPermissions/GrantAndRevokeRolePermissions'),
        props: true,
    },
    {
        path: "grade-profile/editor",
        name: 'Edit Grade Profile',
        component: () => import( /* webpackChunkName: "time-table-editor" */  '../components/Views/Admin/Grading/GradeProfileEditor'),
        props: true
    },

    {
        path: "student-status",
        name: 'Manage Students Status',
        beforeEnter: enforceRequestParameter,
        component: () => import( /* webpackChunkName: "time-table-editor" */  '../components/Views/Admin/StudentStatus/StudentStatus'),
        props: (route) => ({ id: route.query.id }),
    },

    {
        path: "change-of-programme",
        name: 'Change of Programm',
        component: () => import( /* webpackChunkName: "change-of-programme" */ '../components/Views/Admin/ProgrammesAndCourses/ChangeOfProgramme')
    },

    {
        path: 'graduation-management',
        component: () => import( /* webpackChunkName: "admin-graduation-management" */ '../components/Views/Admin/GraduationList/GraduationManagement'),
        children: [

            {
                path: "list",
                name: 'Graduation List Admin Panel',
                component: () => import( /* webpackChunkName: "admin-graduation-list" */ '../components/Views/Admin/GraduationList/GraduationList'),
            },
            {
                path: "graduated-students",
                name: 'Graduated Students Admin Panel',
                component: () => import(/* webpackChunkName: 'admin-graduated-students' */ '../components/Views/Admin/GraduationList/GraduatedStudentsList'),
            }
        ]
    },

    {
        path: "good-standing-management",
        name: 'Admin Good Standing List',
        component: () => import( /* webpackChunkName: "good-standing-management" */ '../components/Views/Admin/GoodStandings/GoodStandingList'),
    },

    {
        path: "students-demography",
        name: "Students Demography",
        component: () =>
            import(
                /* webpackChunkName: 'students-demography' */ "../components/Views/Admin/StudentsDemography.vue"
            ),
    },

    ]
},

{
    //-------------------routings to the ticketing pages-----------------------//
    path: "/tickets",
    name: "Ticketing",
    component: () =>
        import(
                /* webpackChunkName: 'ticketing' */ "../components/Views/Admin/Ticketing/Dashboard"
        ),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkSuperAdminRole,
    children: [
        {
            path: "ticket-dashboard",
            name: "Ticket Dashboard",
            component: () =>
                import(
                        /* webpackChunkName: 'ticketing-home' */ "../components/Views/Admin/Ticketing/Overview"
                ),
        },
        {
            path: "tickets",
            name: "Tickets",
            component: () =>
                import(
                        /* webpackChunkName: 'ticketing-lists' */ "../components/Views/Admin/Ticketing/AdminTickets"
                ),
        },
    ],
},

{ //-------------------routings to the departmental offices------//beforeEnter: checkHODRole,-------------------//
    path: '/department',
    name: 'Department Dashboard',
    component: DepartmentDashboard,
    beforeEnter: checkHODRole,
    meta: { authenticatedUserOnly: true },
    children: [{
        path: 'overview',
        name: 'Department Home',
        component: () => import( /* webpackChunkName: 'department-home' */ '../components/Views/Department/DepartmentOverview')
    },
    {
        path: 'staff',
        name: 'Departmental Staff Members',
        component: () => import( /* webpackChunkName: 'department-staff-list' */ '../components/Views/Department/Staff')
    },
    {
        path: 'programmes',
        name: 'Departmental Programmes',
        component: () => import( /* webpackChunkName: 'departmental-programmes-list' */ "../components/Views/Department/DepartmentalProgrammes")
    },
    {
        path: 'transfer-requests',
        name: 'Department Transfer Requests',
        component: () => import(/* webpackChunkName: 'transfer-requests' */ '../components/Views/Department/Transfers/TransferHome'),
        children: [{
            path: "inbound",
            name: 'Inbound Transfer Requests',
            component: () => import( /* webpackChunkName: "inbound-transfer-requests" */ '../components/Views/Department/Transfers/InboundTransfer'),
        },
        {
            path: "outbound",
            name: 'Outbound Transfer Requests',
            component: () => import( /* webpackChunkName: "outbaound-transfer-requests" */ '../components/Views/Department/Transfers/OutboundTransfer'),
        },

        ]
    },
    {
        path: 'courses',
        name: 'Departmental Courses',
        component: () => import( /* webpackChunkName: 'departmental-courses' */ "../components/Views/Department/DepartmentalCourses")
    },
    {
        path: 'course-allocations',
        name: 'Departmental Course Allocations',
        component: () => import( /* webpackChunkName: 'departmental-course-allocation' */ '../components/Views/Department/CourseAllocations')
    },
    {
        path: 'course-publications',
        name: 'Departmental Course Publications',
        component: () => import( /* webpackChunkName: 'departmental-course-publication' */ '../components/Views/Department/CoursePublications')
    },
    {
        path: "graduating-list",
        name: "Departmental Graduating List",
        component: () =>
            import(
                /* webpackChunkName: 'departmental-graduating-list' */ "../components/Views/Department/GraduatingList/GraduatingList"
            ),
    },
    {
        path: 'academic-advisers',
        name: 'Academic Level Advisers',
        component: () => import( /* webpackChunkName: 'departmental-academic-advisers' */ '../components/Views/Department/LevelAdvisers')
    },
    {
        path: 'appoint-exam-officer',
        name: 'Appoint Exam Officer',
        component: () => import( /* webpackChunkName: 'departmental-appoint-exam-officer' */ '../components/Views/Department/AppointExamOfficer')
    },
    {
        path: 'students',
        name: 'Departmental Students',
        component: () => import( /* webpackChunkName: 'departmental-students-list' */ '../components/Views/Department/Students')
    },
    {
        path: 'students-results',
        name: 'Departmental Students Results',
        component: () => import( /* webpackChunkName: 'departmental-students-results-list' */ '../components/Views/Department/MyStudentResults')
    },
    {
        path: 'cummulative-results',
        name: 'Departmental Cummulative Results',
        component: () => import( /* webpackChunkName: 'departmental-cummulative-results-list' */ '../components/Views/Department/CummulativeResult')
    },
    {
        path: 'student-results/result',
        name: "Departmental Student's Result",
        component: () => import( /* webpackChunkName: 'departmental-students-results' */ '../components/Views/Department/StudentResults'),
        props: true
    },
    {
        path: "course-result-list",
        name: 'Manage Course Result List',
        component: () => import( /* webpackChunkName: "departmental-course-result-list" */ '../components/Views/Department/CourseResultList.vue'),
    },
    {
        path: "assessment-score",
        name: 'Upload Assessment Score',
        component: () => import( /* webpackChunkName: "departmental-assessment-score" */ '../components/Views/Department/AssessmentScore'),
    },
    {
        path: 'students-registration-list',
        component: () => import( /* webpackChunkName: "departmental-students-registration-list-home" */ '../components/Views/Department/StudentsRegistrationList/StudentsRegistration'),
        children: [
            {
                path: '',
                name: 'Departmental View Registration Submission List',
                component: () => import( /* webpackChunkName: "departmental-students-registration-submission-list" */ '../components/Views/Department/StudentsRegistrationList/StudentsRegistrationSubmissionList')
            },
            {
                path: 'enrollment-list',
                name: 'Departmental View Course Enrollment List',
                component: () => import( /* webpackChunkName: "departmental-students-courses-enrollment-list" */ '../components/Views/Department/StudentsRegistrationList/StudentsCoursesEnrollmentList')
            },
        ]
    },
    {
        path: 'course-registrations',
        name: 'Departmental Course Registrations',
        component: () => import( /* webpackChunkName: 'departmental-course-registrations' */ '../components/Views/Department/DepartmentalCoursesRegistrations')
    },
    {
        path: 'extra-credit-applications',
        name: 'Department Extra Credit Applications',
        component: () => import( /* webpackChunkName: 'departmental-extra-credit-applications' */ '../components/Views/Department/ExtraCreditApplications')
    },
    {
        path: 'learned-conference-applications',
        name: 'Department Learned Conference Applications',
        component: () => import( /* webpackChunkName: 'departmental-learned-conference-applications' */ '../components/Views/Department/LearnedConferencesList')
    },
    {
        path: 'clearance-lists',
        name: 'Department Clearance Lists',
        component: () => import( /* webpackChunkName: 'departmental-clearance-lists' */ '../components/Views/Department/ClearanceLists')
    },
    {
        path: 'all-candidates',
        name: 'Department Admission Recommendations',
        component: () => import( /* webpackChunkName: 'departmental-all-candidates' */ '../components/Views/Department/AllCandidates')
    },
    {
        path: "/verify-email",
        name: "Verify Email",
        component: () =>
            import(
                /* webpackChunkName: 'request-email-verification-link' */ "../components/Views/EmailVerification/VerifyEmail"
            ),
        meta: { guestUserOnly: true },
    },
    {
        path: 'departmental-progression',
        name: 'Departmental Students Progresion',
        component: () => import( /* webpackChunkName: 'department-progression' */ '../components/Views/Department/StudentProgression')
    },

    {
        path: "graduation-list",
        name: 'Graduation List',
        component: () => import( /* webpackChunkName: "departmental-graduation-list" */ '../components/Views/Department/GraduationList'),
    },

    {
        path: 'graduation-management',
        component: () => import( /* webpackChunkName: "departmental-graduation-management" */ '../components/Views/Department/GraduationManagement'),
        children: [

            {
                path: "list",
                name: 'Departmental Graduation List',
                component: () => import( /* webpackChunkName: "departmental-graduation-list" */ '../components/Views/Department/GraduationList'),
            },
            {
                path: "graduated-students",
                name: 'Departmental Graduated Students',
                component: () => import(/* webpackChunkName: 'departmental-graduated-students' */ '../components/Views/Department/GraduatedStudentsList'),
            }
        ]
    },
    {
        path: "good-standing-management",
        name: 'Departmental Good Standing List',
        component: () => import( /* webpackChunkName: "departmental-good-standing-management" */ '../components/Views/Department/GoodStandingList'),
    },

    ]
},

{ //-------------------routings to the curriculum management pages-----------------------//
    path: '/department/curriculum',
    name: 'CurriculumDevelopment',
    beforeEnter: checkHODRole,
    component: () => import( /* webpackChunkName: 'curriculum' */ '../components/Views/Department/Curriculum/Dashboard'),
    meta: { authenticatedUserOnly: true },
    children: [

        {
            path: 'departmental-curriculum-dashboard',
            name: 'Department Curriculum',
            component: () => import( /* webpackChunkName: 'departmental-curriculum-dashboard' */ '../components/Views/Department/Curriculum/CurriculumOverview'),
        },
        {
            path: "all-curricula",
            name: 'All Curricula',
            component: () => import( /* webpackChunkName: "all-curricula" */ '../components/Views/Department/Curriculum/Curriculums'),
        },
        {
            path: "/manage-curriculum/:id",
            name: "Curriculum Management",
            component: () =>
                import(
                    /* webpackChunkName: 'manage-curriculum' */ "../components/Views/Department/Curriculum/CurriculumManagement"
                ),
            props: true,
            mode: "params",
        },
        {
            path: "curriculum-allocations",
            name: 'Curriculum Allocations',
            component: () => import( /* webpackChunkName: "curriculum-allocations" */ '../components/Views/Department/Curriculum/CurriculumAllocations'),
        },
        {
            path: "course-specialization",
            name: 'Course Specialization',
            component: () => import( /* webpackChunkName: "course-specialization" */ '../components/Views/Department/Curriculum/CourseSpecialization'),
        },
        {
            path: "course-groups",
            name: 'Course Group',
            component: () => import( /* webpackChunkName: "course-groups" */ '../components/Views/Department/Curriculum/CourseGroups'),
        },
        {
            path: "course-durations",
            name: 'Course Durations',
            component: () => import( /* webpackChunkName: "course-durations" */ '../components/Views/Department/Curriculum/CourseDurations'),
        },
        {
            path: "graduation-requirements",
            name: 'Graduation Requirements',
            component: () => import( /* webpackChunkName: "graduation-requirements" */ '../components/Views/Department/Curriculum/GraduationRequirements'),
        },
    ]
},

{ //-------------------routings to the curriculum management pages-----------------------//
    path: '/cordinator/curriculum',
    name: 'Cordinator Curriculum Development',
    beforeEnter: checkCordinatorRole,
    component: () => import( /* webpackChunkName: 'cordinator-curriculum' */ '../components/Views/Cordinator/Curriculum/Dashboard'),
    meta: { authenticatedUserOnly: true },
    children: [

        {
            path: 'curriculum-dashboard',
            name: 'Cordinator Curriculum',
            component: () => import( /* webpackChunkName: 'cordinator-curriculum-dashboard' */ '../components/Views/Cordinator/Curriculum/CurriculumOverview'),
        },
        {
            path: "all-curricula",
            name: 'Cordinator All Curricula',
            component: () => import( /* webpackChunkName: "cordinator-all-curricula" */ '../components/Views/Cordinator/Curriculum/Curriculums'),
        },
        {
            path: "cordinator/manage-curriculum/:id",
            name: "Cordinator Curriculum Management",
            component: () =>
                import(
                    /* webpackChunkName: 'cordinator-manage-curriculum' */ "../components/Views/Cordinator/Curriculum/CurriculumManagement"
                ),
            props: true,
            mode: "params",
        },
        {
            path: "curriculum-allocations",
            name: 'Cordinator Curriculum Allocations',
            component: () => import( /* webpackChunkName: "cordinator-curriculum-allocations" */ '../components/Views/Cordinator/Curriculum/CurriculumAllocations'),
        },
        {
            path: "course-specialization",
            name: 'Cordinator Course Specialization',
            component: () => import( /* webpackChunkName: "cordinator-course-specialization" */ '../components/Views/Cordinator/Curriculum/CourseSpecialization'),
        },
        {
            path: "course-groups",
            name: 'Cordinator Course Group',
            component: () => import( /* webpackChunkName: "cordinator-course-groups" */ '../components/Views/Cordinator/Curriculum/CourseGroups'),
        },
        {
            path: "course-durations",
            name: 'Cordinator Course Durations',
            component: () => import( /* webpackChunkName: "cordinator-course-durations" */ '../components/Views/Cordinator/Curriculum/CourseDurations'),
        },
        {
            path: "graduation-requirements",
            name: 'Cordinator Graduation Requirements',
            component: () => import( /* webpackChunkName: "cordinator-graduation-requirements" */ '../components/Views/Cordinator/Curriculum/GraduationRequirements'),
        },
    ]
},



{ //-------------------routings to the cordinator offices------//beforeEnter: checkHODRole,-------------------//
    path: '/cordinator',
    name: 'Cordinator Dashboard',
    component: CordinatorDashboard,
    beforeEnter: checkCordinatorRole,
    meta: { authenticatedUserOnly: true },
    children: [{
        path: 'overview',
        name: 'Cordinator Home',
        component: () => import( /* webpackChunkName: 'cordinator-home' */ '../components/Views/Cordinator/Overview')
    },
    {
        path: 'staff',
        name: 'Cordinator Staff Members',
        component: () => import( /* webpackChunkName: 'cordinator-staff-list' */ '../components/Views/Cordinator/Staff')
    },
    {
        path: 'programmes',
        name: 'Cordinator Programmes',
        component: () => import( /* webpackChunkName: 'cordinator-programmes-list' */ "../components/Views/Cordinator/Programmes")
    },
    {
        path: 'transfer-requests',
        name: 'Cordinator Transfer Requests',
        component: () => import(/* webpackChunkName: 'cordinator-transfer-requests' */ '../components/Views/Cordinator/Transfers/TransferHome'),
        children: [{
            path: "inbound",
            name: 'Institute Inbound Transfer Requests',
            component: () => import( /* webpackChunkName: "cordinator-inbound-transfer-requests" */ '../components/Views/Cordinator/Transfers/InboundTransfer'),
        },
        {
            path: "outbound",
            name: 'Institute Outbound Transfer Requests',
            component: () => import( /* webpackChunkName: "cordinator-outbound-teransfer-requests" */ '../components/Views/Cordinator/Transfers/OutboundTransfer'),
        },

        ]
    },
    {
        path: 'courses',
        name: 'Cordinator Courses',
        component: () => import( /* webpackChunkName: 'cordinator-courses' */ "../components/Views/Cordinator/Courses")
    },
    {
        path: 'course-allocations',
        name: 'Cordinator Course Allocations',
        component: () => import( /* webpackChunkName: 'cordinator-course-allocation' */ '../components/Views/Cordinator/CourseAllocations')
    },
    {
        path: 'academic-advisers',
        name: 'Instite Academic Level Advisers',
        component: () => import( /* webpackChunkName: 'cordinator-academic-advisers' */ '../components/Views/Cordinator/LevelAdvisers')
    },
    {
        path: 'appoint-exam-officer',
        name: 'Institute Appoint Exam Officer',
        component: () => import( /* webpackChunkName: 'cordinator-appoint-exam-officer' */ '../components/Views/Cordinator/AppointExamOfficer')
    },
    {
        path: 'students',
        name: 'Cordinator Students',
        component: () => import( /* webpackChunkName: 'cordinator-students-list' */ '../components/Views/Cordinator/Students')
    },
    {
        path: 'students-results',
        name: 'Cordinator Students Results',
        component: () => import( /* webpackChunkName: 'cordinator-students-results-list' */ '../components/Views/Cordinator/MyStudentResults')
    },
    {
        path: 'student-results/result',
        name: "Cordinator Student's Result",
        component: () => import( /* webpackChunkName: 'cordinator-students-results' */ '../components/Views/Cordinator/StudentResults'),
        props: true
    },
    {
        path: "assessment-score",
        name: 'Cordinator Upload Assessment Score',
        component: () => import( /* webpackChunkName: "cordinator-assessment-score" */ '../components/Views/Cordinator/AssessmentScore'),
    },
    {
        path: 'course-publications',
        name: 'Cordinator Course Publications',
        component: () => import( /* webpackChunkName: 'cordinator-course-publication' */ '../components/Views/Cordinator/CoursePublications')
    },
    {
        path: 'students-registration-list',
        component: () => import( /* webpackChunkName: "cordinator-students-registration-list-home" */ '../components/Views/Cordinator/StudentsRegistrationList/StudentsRegistration'),
        children: [
            {
                path: '',
                name: 'Cordinator View Registration Submission List',
                component: () => import( /* webpackChunkName: "cordinator-students-registration-submission-list" */ '../components/Views/Cordinator/StudentsRegistrationList/StudentsRegistrationSubmissionList')
            },
            {
                path: 'enrollment-list',
                name: 'Cordinator View Course Enrollment List',
                component: () => import( /* webpackChunkName: "cordinator-students-courses-enrollment-list" */ '../components/Views/Cordinator/StudentsRegistrationList/StudentsCoursesEnrollmentList')
            },
        ]
    },
    {
        path: 'course-registrations',
        name: 'Cordinator Course Registrations',
        component: () => import( /* webpackChunkName: 'cordinator-course-registrations' */ '../components/Views/Cordinator/CoursesRegistrations')
    },
    {
        path: "students-course-reg/documents",
        name: "Cordinator Student's Course Registration Documents",
        component: () =>
            import(
                /* webpackChunkName: 'cordinator-students-course-registration-documents' */ "../components/Views/Cordinator/StudentCourseRegistrationDocuments"
            ),
        props: true,
    },
    {
        path: 'extra-credit-applications',
        name: 'Cordiantor Extra Credit Applications',
        component: () => import( /* webpackChunkName: 'cordinator-extra-credit-applications' */ '../components/Views/Cordinator/ExtraCreditApplications')
    },
    {
        path: "course-specifications",
        name: "Cordinator Course Specifications ",
        component: () =>import( /* webpackChunkName: 'cordinator-course-specifications' */ "../components/Views/Cordinator/CourseSpecification"
            ),
    },
    {
        path: 'departmental-progression',
        name: 'Cordinator Students Progresion',
        component: () => import( /* webpackChunkName: 'cordinator-progression' */ '../components/Views/Cordinator/StudentProgression')
    },

    {
        path: 'graduation-management',
        component: () => import( /* webpackChunkName: "coordinator-graduation-management" */ '../components/Views/Cordinator/GraduationList/GraduationManagement'),
        children: [

            {
                path: "list",
                name: 'Graduation List Cordinator Panel',
                component: () => import( /* webpackChunkName: "cordinator-graduation-list" */ '../components/Views/Cordinator/GraduationList/GraduationList'),
            },
            {
                path: "graduated-students",
                name: 'Graduated Students Cordinator Panel',
                component: () => import(/* webpackChunkName: 'coordinator-graduated-students' */ '../components/Views/Cordinator/GraduationList/GraduatedStudentsList'),
            }
        ]
    },

    {
        path: "good-standing-management",
        name: 'Cordinator Good Standing List',
        component: () => import( /* webpackChunkName: "cordinator-good-standing-management" */ '../components/Views/Cordinator/GoodStandingList'),
    },

    {
        path: 'departmental-progression',
        name: 'Departmental Progression', // Changed name
        component: () => import( /* webpackChunkName: 'cordinator-progression' */ '../components/Views/Cordinator/StudentProgression')
    }


    ]
},

{ //-------------------routings to the departmental offices------//beforeEnter: checkHODRole,-------------------//
    path: '/director',
    name: 'Director Dashboard',
    component: DirectorDashboard,
    beforeEnter: checkDirectorRole,
    meta: { authenticatedUserOnly: true },
    children: [{
        path: 'overview',
        name: 'Director Home',
        component: () => import( /* webpackChunkName: 'director-home' */ '../components/Views/Director/Overview')
    },
    {
        path: 'courses',
        name: 'Director Courses',
        component: () => import( /* webpackChunkName: 'director-courses' */ "../components/Views/Director/Courses")
    },
    {
        path: 'course-allocations',
        name: 'Director Course Allocations',
        component: () => import( /* webpackChunkName: 'director-course-allocation' */ '../components/Views/Director/CourseAllocations')
    },
    {
        path: 'course-publications',
        name: 'Director Course Publications',
        component: () => import( /* webpackChunkName: 'director-course-publication' */ '../components/Views/Director/CoursePublications')
    },
    {
        path: 'appoint-exam-officer',
        name: 'Director Appoint Exam Officer',
        component: () => import( /* webpackChunkName: 'director-appoint-exam-officer' */ '../components/Views/Director/AppointExamOfficer')
    },
    {
        path: "assessment-score",
        name: 'Director Upload Assessment Score',
        component: () => import( /* webpackChunkName: "director-assessment-score" */ '../components/Views/Director/AssessmentScore'),
    },
    {
        path: 'course-registrations',
        name: 'Director Course Registrations',
        component: () => import( /* webpackChunkName: 'director-course-registrations' */ '../components/Views/Director/CoursesRegistrations')
    },
    {
        path: "good-standing-management",
        name: 'Director Good Standing List',
        component: () => import( /* webpackChunkName: "director-good-standing-management" */ '../components/Views/Director/GoodStandingList'),
    },
    ]
},

{ //-------------------routings to the hostel management pages-----------------------//
    path: '/institute/hostel',
    name: 'Hostel',
    component: () => import( /* webpackChunkName: 'institute-hostel' */ '../components/Views/Institutes/HostelModule/Dashboard'),
    meta: { authenticatedUserOnly: true },
    children: [

        {
            path: 'hostel-dashboard',
            name: 'Institutes Hostel Management Dashboard',
            component: () => import( /* webpackChunkName: 'institute-hostel-dashboard' */ '../components/Views/Institutes/HostelModule/HostelOverview.vue'),
        },
        {
            path: "hostels",
            //name: 'Manage Hostels And Hostel Blocks',
            component: () => import( /* webpackChunkName: "institute-hostels-and-hostel-blocks" */ '../components/Views/Institutes/HostelModule/HostelsAndHostelBlocks'),
            //props: true,
            children: [{
                path: "",
                name: 'Manage Hostels',
                component: () => import( /* webpackChunkName: "institute-manage-hostels" */ '../components/Views/Institutes/HostelModule/Hostels')
            },
            {
                path: "hostel-blocks",
                name: 'Institutes Manage Hostel Blocks',
                component: () => import( /* webpackChunkName: "institute-hostel-blocks" */ '../components/Views/Institutes/HostelModule/HostelBlocks')
            },
            ]
        },
        {
            path: 'hostel-block-allocation',
            name: 'Institutes Hostel Block Allocations',
            component: () => import( /* webpackChunkName: 'institute-hostel-block-allocation' */ '../components/Views/Institutes/HostelModule/HostelBlockAllocation'),

        },
        {
            path: "rooms",
            //name: 'Manage Hostel Rooms And Bedspaces',
            component: () => import( /* webpackChunkName: "institute-hostel-rooms-and-bedspaces" */ '../components/Views/Institutes/HostelModule/RoomsAndBedspaces'),
            //props: true,
            children: [{
                path: "",
                name: 'Institutes Manage Hostel Rooms',
                component: () => import( /* webpackChunkName: "institute-manage-rooms" */ '../components/Views/Institutes/HostelModule/Rooms')
            },
            {
                path: "bedspaces",
                name: 'Institutes Manage Bed Spaces',
                component: () => import( /* webpackChunkName: "institute-hostel-bed-spaces" */ '../components/Views/Institutes/HostelModule/BedSpaces')
            },
            ]
        },

        {
            path: "reservation-and-allocations",
            //name: 'Manage Reservations And Allocations',
            component: () => import( /* webpackChunkName: "institute-bedspace-reservation-and-allocations" */ '../components/Views/Institutes/HostelModule/BedSpaceReservationsAndAllocations'),
            //props: true,
            children: [{
                path: "",
                name: 'Institutes Manage Bedspace Allocations',
                component: () => import( /* webpackChunkName: "institute-manage-bed-space-allocations" */ '../components/Views/Institutes/HostelModule/Reservations')
            },
            {
                path: "allocations",
                name: 'Institutes Manage Allocations',
                component: () => import( /* webpackChunkName: "institute-allocations" */ '../components/Views/Institutes/HostelModule/Allocations')
            },
            ]
        },

        {
            path: "hostel-balloting-schedule",
            name: 'Hostel Balloting Schedule',
            component: () => import( /* webpackChunkName: "institute-hostel-balloting-schedule" */ '../components/Views/Institutes/HostelModule/HostelBallotingSchedule')
        },

        {
            path: "manual-reservation",
            name: 'Manual Reservation',
            component: () => import( /* webpackChunkName: "institute-manual-hostel-reservation" */ '../components/Views/Institutes/HostelModule/ManualReservation')
        },

        {
            path: "manual-allocation",
            name: 'Manual Allocation',
            component: () => import( /* webpackChunkName: "institute-manual-hostel-allocation" */ '../components/Views/Institutes/HostelModule/ManualAllocation')
        },

    ]
},

{
    //-------------------routings to the level adviser offices------//beforeEnter: checkHODRole,-------------------//
    path: "/academic-adviser",
    name: "Academic Adviser Dashboard",
    component: AdviserDashboard,
    beforeEnter: checkLevelAdviserRole,
    meta: { authenticatedUserOnly: true },
    children: [
        {
            path: "overview",
            name: "Academic Level Adviser Home",
            component: () =>
                import(
                    /* webpackChunkName: 'academic-adviser-home' */ "../components/Views/AcademicLevelAdviser/AdviserOverview"
                ),
        },
        {
            path: "course-registration-template",
            name: "Level Course Registration Template ",
            component: () =>
                import(
                    /* webpackChunkName: 'academic-adviser-course-specification' */ "../components/Views/AcademicLevelAdviser/CourseSpecification"
                ),
        },
        {
            path: "my-students",
            name: "My Students",
            component: () =>
                import(
                    /* webpackChunkName: 'academic-adviser-students-list' */ "../components/Views/AcademicLevelAdviser/MyStudents.vue"
                ),
        },
        {
            path: 'cummulative-results',
            name: 'LA Cummulative Results',
            component: () => import( /* webpackChunkName: 'departmental-cummulative-results-list' */ '../components/Views/AcademicLevelAdviser/CummulativeResult')
        },
        {
            path: "students-course-reg",
            name: "My Students Course Registration",
            component: () =>
                import(
                    /* webpackChunkName: 'academic-adviser-students-course-registration' */ "../components/Views/AcademicLevelAdviser/MyStudentsCourseRegistration.vue"
                ),
        },
        {
            path: "students-course-reg/documents",
            name: "Student's Course Registration Documents",
            component: () =>
                import(
                    /* webpackChunkName: 'academic-adviser-students-course-registration-documents' */ "../components/Views/AcademicLevelAdviser/StudentCourseRegistrationDocuments"
                ),
            props: true,
        },
        {
            path: 'my-student-results',
            name: 'My Student Results',
            component: () => import( /* webpackChunkName: 'academic-adviser-students-result-list' */ '../components/Views/AcademicLevelAdviser/MyStudentResults')
        },
        {
            path: 'my-student-results/result',
            name: "Student's Result",
            component: () => import( /* webpackChunkName: 'academic-adviser-students-result' */ '../components/Views/AcademicLevelAdviser/StudentResults'),
            props: true
        },
        {
            path: "students-extra-credit-applications",
            name: 'Academic Adviser Extra Credit Applications',
            component: () => import(/* webpackChunkName: 'academic-adviser-student-extra-credit-applications' */ '../components/Views/AcademicLevelAdviser/ExtraCreditApplications'),
        },
        {
            path: "good-standing-management",
            name: 'Academic Adviser Good Standing List',
            component: () => import( /* webpackChunkName: "academic-adviser-good-standing-management" */ '../components/Views/AcademicLevelAdviser/GoodStandingList'),
        },
        {
            path: 'progression',
            name: 'Academic Adviser Students Progresion',
            component: () => import( /* webpackChunkName: 'academic-adviser-progression' */ '../components/Views/AcademicLevelAdviser/StudentProgression')
        },
    ]
},

{
    //-------------------routings to the level adviser offices------//beforeEnter: checkHODRole,-------------------//
    path: "/department-exam-officer",
    name: "Department Exam Officer Dashboard",
    component: ExamOfficerDashboard,
    beforeEnter: checkDepartmentExamOfficerRole,
    meta: { authenticatedUserOnly: true },
    children: [
        {
            path: "overview",
            name: "Department Exam Officer Home",
            component: () =>
                import(
                    /* webpackChunkName: 'department-exam-officer-home' */ "../components/Views/Department/ExamOffice/ExamOfficerOverview"
                ),
        },
        {
            path: "students",
            name: "Department Exam Officer Students",
            component: () =>
                import(
                    /* webpackChunkName: 'department-exam-officer-students-list' */ "../components/Views/Department/ExamOffice/Students.vue"
                ),
        },
        {
            path: 'students-results',
            name: 'Department Exam Officer Students Results',
            component: () => import( /* webpackChunkName: 'department-exam-officer-students-results-list' */ '../components/Views/Department/ExamOffice/MyStudentResults')
        },
        {
            path: 'student-results/result',
            name: "Department Exam Officer Student's Result",
            component: () => import( /* webpackChunkName: 'department-exam-officer-students-results' */ '../components/Views/Department/ExamOffice/StudentResults'),
            props: true
        },
        // {
        //     path: "assessment-score",
        //     name: 'Upload Assessment Score',
        //     component: () => import( /* webpackChunkName: "department-exam-officer-assessment-score" */ '../components/Views/Department/ExamOffice/AssessmentScore'),
        // },
        {
            path: 'courses',
            name: 'Department Exam Officer Courses',
            component: () => import( /* webpackChunkName: 'department-exam-officer-courses' */ "../components/Views/Department/ExamOffice/DepartmentalCourses")
        },
        {
            path: 'course-registrations',
            name: 'Department Exam Officer Course Registrations',
            component: () => import( /* webpackChunkName: 'department-exam-officer-course-registrations' */ '../components/Views/Department/ExamOffice/CoursesRegistrations')
        },
        {
            path: 'course-allocations',
            name: 'Department Exam Officer Course Allocations',
            component: () => import( /* webpackChunkName: 'department-exam-officer-course-allocation' */ '../components/Views/Department/ExamOffice/CourseAllocations')
        },
        {
            path: 'staff',
            name: 'Department Exam Officer Staff Members',
            component: () => import( /* webpackChunkName: 'department-exam-officer-staff-list' */ '../components/Views/Department/ExamOffice/Staff')
        },
        {
            path: 'students-registration-list',
            component: () => import( /* webpackChunkName: "department-exam-officer-students-registration-list-home" */ '../components/Views/Department/ExamOffice/StudentsRegistrationList/StudentsRegistration'),
            children: [
                {
                    path: '',
                    name: 'Department Exam Officer View Registration Submission List',
                    component: () => import( /* webpackChunkName: "department-exam-officer-students-registration-submission-list" */ '../components/Views/Department/ExamOffice/StudentsRegistrationList/StudentsRegistrationSubmissionList')
                },
                {
                    path: 'enrollment-list',
                    name: 'Department Exam Officer View Course Enrollment List',
                    component: () => import( /* webpackChunkName: "department-exam-officer-students-courses-enrollment-list" */ '../components/Views/Department/ExamOffice/StudentsRegistrationList/StudentsCoursesEnrollmentList')
                },
            ]
        },
    ]
},

{ //-------------------routings to the faculty offices------//beforeEnter: check if role is dean or subdean,-------------------//
    path: '/faculty',
    name: 'Faculty Dashboard',
    component: FacultyDashboard,
    beforeEnter: checkRole,
    meta: { authenticatedUserOnly: true },
    children: [{
        path: 'overview',
        name: 'Faculty Home',
        component: () => import( /* webpackChunkName: 'faculty-home' */ '../components/Views/Faculty/FacultyOverview')
    },
    {
        path: 'departments',
        name: 'Departments',
        component: () => import( /* webpackChunkName: 'faculty-departments-list' */ '../components/Views/Faculty/FacultyDepartments')
    },
    {
        path: 'staff',
        component: () => import( /* webpackChunkName: 'faculty-staff-list' */ '../components/Views/Faculty/Staff')
    },
    {
        path: 'hods',
        name: 'Head of Department',
        component: () => import( /* webpackChunkName: 'faculty-hods' */ '../components/Views/Faculty/HODs')
    },
    {
        path: 'academic-advisers',
        name: 'Faculty Academic Level Advisers',
        component: () => import( /* webpackChunkName: 'faculty-academic-advisers' */ '../components/Views/Faculty/LevelAdvisers')
    },
    {
        path: 'students',
        name: 'Faculty Students',
        component: () => import( /* webpackChunkName: 'faculty-students-list' */ '../components/Views/Faculty/Students')
    },
    {
        path: 'students-results',
        name: 'Faculty Students Results',
        component: () => import( /* webpackChunkName: 'faculty-students-results' */ '../components/Views/Faculty/StudentsResults')
    },

    {
        path: 'student-results/result',
        name: "Faculty Student's Result",
        component: () => import( /* webpackChunkName: 'faculty-students-result' */ '../components/Views/Faculty/StudentResults'),
        props: true
    },
    {
        path: 'programmes',
        name: 'Faculty Programmes',
        component: () => import( /* webpackChunkName: 'faculty-programmes-list' */ "../components/Views/Faculty/FacultyProgrammes")
    },
    {
        path: 'courses',
        name: 'Faculty Courses',
        component: () => import( /* webpackChunkName: 'faculty-courses' */ "../components/Views/Faculty/FacultyCourses")
    },

    {
        path: 'course-registrations',
        name: 'Faculty Course Registrations',
        component: () => import( /* webpackChunkName: 'faculty-course-registrations' */ '../components/Views/Faculty/CoursesRegistrations')
    },
    {
        path: 'extra-credit-applications',
        name: 'Faculty Extra Credit Applications',
        component: () => import( /* webpackChunkName: 'faculty-extra-credit-applications' */ '../components/Views/Faculty/ExtraCreditApplications')
    },
    {
        path: 'learned-conference-applications',
        name: 'Faculty Learned Conference Applications',
        component: () => import( /* webpackChunkName: 'faculty-learned-conference-applications' */ '../components/Views/Faculty/LearnedConferencesList')
    },
    {
        path: 'clearance-lists',
        name: 'Faculty Clearance Lists',
        component: () => import( /* webpackChunkName: 'faculty-clearance-lists' */ '../components/Views/Faculty/ClearanceLists')
    },
    {
        path: 'all-candidates',
        name: 'Faculty Admission Recommendations',
        component: () => import( /* webpackChunkName: 'faculty-all-candidates' */ '../components/Views/Faculty/AllCandidates')
    },
    {
        path: "course-result-list",
        name: 'Manage Course Result List',
        component: () => import( /* webpackChunkName: "faculty-course-result-list" */ '../components/Views/Faculty/CourseResultList.vue'),
    },
    {
        path: 'students-registration-list',
        component: () => import( /* webpackChunkName: "faculty-students-registration-list-home" */ '../components/Views/Faculty/StudentsRegistrationList/StudentsRegistration'),
        children: [
            {
                path: '',
                name: 'Faculty View Registration Submission List',
                component: () => import( /* webpackChunkName: "faculty-students-registration-submission-list" */ '../components/Views/Faculty/StudentsRegistrationList/StudentsRegistrationSubmissionList')
            },
            {
                path: 'enrollment-list',
                name: 'Faculty View Course Enrollment List',
                component: () => import( /* webpackChunkName: "faculty-students-courses-enrollment-list" */ '../components/Views/Faculty/StudentsRegistrationList/StudentsCoursesEnrollmentList')
            },
        ]
    },
    {
        path: 'exam-officers',
        name: 'Appoint Faculty Exam Officer',
        component: () => import( /* webpackChunkName: 'faculty-appoint-exam-officer' */ '../components/Views/Faculty/AppointExamOfficer')
    },
    {
        path: 'departments-overview',
        name: 'Departments Overview',
        component: () => import( /* webpackChunkName: 'departments-overview' */ "../components/Views/Faculty/AllDepartmentsOverview"),
    },
    {
        path: '/departments-overview/department/:id',
        name: 'Department Overview',
        component: () => import( /* webpackChunkName: 'department-overview' */ "../components/Views/Faculty/SelectedDepartmentOverview"),


    },
    {
        path: 'department-staff/:id',
        name: 'Selected Department Staff',
        component: () => import( /* webpackChunkName: 'selected-department-staff' */ '../components/Views/Faculty/Department/Staff')
    },
    {
        path: 'department-students/:id',
        name: 'Selected Department Students',
        component: () => import( /* webpackChunkName: 'selected-department-students' */ '../components/Views/Faculty/Department/Students')
    },
    {
        path: 'department-programmes/:id',
        name: 'Selected Department Programmes',
        component: () => import( /* webpackChunkName: 'selected-department-programmes' */ '../components/Views/Faculty/Department/Programmes')
    },
    {
        path: 'department-courses/:id',
        name: 'Selected Department Courses',
        component: () => import( /* webpackChunkName: 'selected-department-courses' */ '../components/Views/Faculty/Department/Courses')
    },
    {
        path: 'graduation-management',
        component: () => import( /* webpackChunkName: "faculty-graduation-management" */ '../components/Views/Faculty/GraduationManagement'),
        children: [

            {
                path: "list",
                name: 'Faculty Graduation List',
                component: () => import( /* webpackChunkName: "faculty-graduation-list" */ '../components/Views/Faculty/GraduationList'),
            },
            {
                path: "graduated-students",
                name: 'Faculty Graduated Students',
                component: () => import(/* webpackChunkName: 'faculty-graduated-students' */ '../components/Views/Faculty/GraduatedStudentsList'),
            }
        ]
    },
    {
        path: "good-standing-management",
        name: 'Faculty Good Standing List',
        component: () => import( /* webpackChunkName: "faculty-good-standing-management" */ '../components/Views/Faculty/GoodStandingList'),
    },
    ]
},

{ //-------------------routings to the faculty offices------//beforeEnter: check if role is dean or subdean,-------------------//
    path: '/faculty-exam-officer',
    name: 'Faculty Exam Officer Dashboard',
    component: FacultyExamOfficerDashboard,
    beforeEnter: checkFacultyExamOfficerRole,
    meta: { authenticatedUserOnly: true },
    children: [{
        path: 'overview',
        name: 'Faculty Exam Officer Home',
        component: () => import( /* webpackChunkName: 'faculty-exam-officer-home' */ '../components/Views/Faculty/ExamOffice/Overview')
    },
    {
        path: 'departments',
        name: 'Faculty Exam Officer Departments',
        component: () => import( /* webpackChunkName: 'faculty-exam-officer-departments-list' */ '../components/Views/Faculty/ExamOffice/FacultyDepartments')
    },
    {
        path: 'programmes',
        name: 'Faculty Exam Officer Programmes',
        component: () => import( /* webpackChunkName: 'faculty-exam-officer-programmes-list' */ "../components/Views/Faculty/ExamOffice/FacultyProgrammes")
    },
    {
        path: 'course-allocations',
        name: 'Faculty Exam Officer Course Allocations',
        component: () => import( /* webpackChunkName: 'faculty-exam-officer-course-allocation' */ '../components/Views/Faculty/ExamOffice/CourseAllocations')
    },
    {
        path: 'staff',
        name: 'Faculty Exam Officer Staff Members',
        component: () => import( /* webpackChunkName: 'faculty-exam-officer-staff-list' */ '../components/Views/Faculty/ExamOffice/Staff')
    },
    {
        path: 'hods',
        name: 'Faculty Exam Officer Head of Department',
        component: () => import( /* webpackChunkName: 'faculty-exam-officer-hods' */ '../components/Views/Faculty/ExamOffice/HODs')
    },
    {
        path: 'students',
        name: 'Faculty Exam Officer Students',
        component: () => import( /* webpackChunkName: 'faculty-exam-officer-students-list' */ '../components/Views/Faculty/ExamOffice/Students')
    },
    {
        path: 'students-results',
        name: 'Faculty Exam Officer Students Results',
        component: () => import( /* webpackChunkName: 'faculty-exam-officer-students-results' */ '../components/Views/Faculty/ExamOffice/StudentsResults')
    },

    {
        path: 'student-results/result',
        name: "Faculty Exam Officer Student's Result",
        component: () => import( /* webpackChunkName: 'faculty-exam-officer-students-result' */ '../components/Views/Faculty/ExamOffice/StudentResults'),
        props: true
    },
    {
        path: 'courses',
        name: 'Faculty Exam Officer Courses',
        component: () => import( /* webpackChunkName: 'faculty-exam-officer-courses' */ "../components/Views/Faculty/ExamOffice/FacultyCourses")
    },
    {
        path: 'course-registrations',
        name: 'Faculty Exam Officer Course Registrations',
        component: () => import( /* webpackChunkName: 'faculty-exam-officer-course-registrations' */ '../components/Views/Faculty/ExamOffice/CoursesRegistrations')
    },
    {
        path: 'students-registration-list',
        component: () => import( /* webpackChunkName: "faculty-exam-officer-students-registration-list-home" */ '../components/Views/Faculty/ExamOffice/StudentsRegistrationList/StudentsRegistration'),
        children: [
            {
                path: '',
                name: 'Faculty Exam Officer View Registration Submission List',
                component: () => import( /* webpackChunkName: "faculty-exam-officer-students-registration-submission-list" */ '../components/Views/Faculty/ExamOffice/StudentsRegistrationList/StudentsRegistrationSubmissionList')
            },
            {
                path: 'enrollment-list',
                name: 'Faculty Exam Officer View Course Enrollment List',
                component: () => import( /* webpackChunkName: "faculty-exam-officer-students-courses-enrollment-list" */ '../components/Views/Faculty/ExamOffice/StudentsRegistrationList/StudentsCoursesEnrollmentList')
            },
        ]
    },
    ]
},

{ //-------------------routings to the faculty offices------//beforeEnter: check if role is dean or subdean,-------------------//
    path: '/administrative-officer',
    name: 'Faculty Officer Dashboard',
    component: AdministrativeOfficerDashboard,
    beforeEnter: checkAdministrativeOfficerRole,
    meta: { authenticatedUserOnly: true },
    children: [{
        path: 'overview',
        name: 'Faculty Officer Home',
        component: () => import( /* webpackChunkName: 'administrative-officer-home' */ '../components/Views/AdministrativeOfficer/Overview')
    },
    {
        path: 'clearance-lists',
        name: 'Administrative Clearance Lists',
        component: () => import( /* webpackChunkName: 'administrative-officer-clearance-lists' */ '../components/Views/AdministrativeOfficer/ClearanceLists')
    },
    ]
},

{ //-------------------routings to the faculty offices------//beforeEnter: check if role is dean or subdean,-------------------//
    path: '/finance-officer',
    name: 'Faculty Accountant Dashboard',
    component: FinanceOfficerDashboard,
    beforeEnter: checkFinanceOfficerRole,
    meta: { authenticatedUserOnly: true },
    children: [{
        path: 'overview',
        name: 'Faculty Accountant Home',
        component: () => import( /* webpackChunkName: 'finance-officer-home' */ '../components/Views/FinanceOfficer/Overview')
    },
    {
        path: 'clearance-lists',
        name: 'Faculty Accountant Clearance Lists',
        component: () => import( /* webpackChunkName: 'finance-officer-clearance-lists' */ '../components/Views/FinanceOfficer/ClearanceLists')
    },
    ]
},

{ //-------------------routings to the faculty offices------//beforeEnter: check if role is dean or subdean,-------------------//
    path: '/hostel-manager',
    name: 'Hostel Manager Dashboard',
    component: HostelManagerDashboard,
    beforeEnter: checkHostelManagerRole,
    meta: { authenticatedUserOnly: true },
    children: [{
        path: 'overview',
        name: 'Hostel Manager Home',
        component: () => import( /* webpackChunkName: 'hostel-manager-home' */ '../components/Views/HostelManager/Overview')
    },
    {
        path: 'clearance-lists',
        name: 'Hostel Manager Clearance Lists',
        component: () => import( /* webpackChunkName: 'hostel-manager-clearance-lists' */ '../components/Views/HostelManager/ClearanceLists')
    },
    ]
},

{ //-------------------routings to institute------//beforeEnter: checkAdmissionOfficerRole,-------------------//
    path: '/institute',
    name: 'Institute',
    props: true,
    component: () => import( /* webpackChunkName: 'institutes' */ '../components/Views/Institutes/Dashboard'),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkSuperAdminOrDirectorRole,
    children: [
        {
            path: 'overview',
            name: 'Institute Dashboard',
            component: () => import( /* webpackChunkName: 'institute-home' */ '../components/Views/Institutes/InstituteOverview'),
        },

        {
            path: 'academic_sessions',
            // name: 'Manage Sessions & Semseters',
            component: () => import( /* webpackChunkName: "semester-and-session-home" */ '../components/Views/Institutes/SessionsAndSemesters/SessionsAndSemesters'),
            children: [{
                path: '',
                name: 'Institute Manage Academic Sessions',
                component: () => import( /* webpackChunkName: "academic-sessions-list" */ '../components/Views/Institutes/SessionsAndSemesters/AcademicSessions.vue'),
            },
            {
                path: "semesters",
                name: 'Institute Manage Semesters',
                component: () => import( /* webpackChunkName: "semesters-list" */ '../components/Views/Institutes/SessionsAndSemesters/Semesters'),
            },
            {
                path: 'session_semester_settings',
                name: 'Institute Session & Semseter Configurations',
                component: () => import( /* webpackChunkName: "session-semester-setting" */ '../components/Views/Institutes/SessionsAndSemesters/SessionAndSemesterSettings')
            },
            ]
        },

        {
            path: 'extra-credit-applications',
            component: () => import(/* webpackChunkName: 'institute-extra-credit-applications' */ '../components/Views/Institutes/ExtraCreditApplications/ExtraCreditApplicationHome'),
            children: [
                {
                    path: '',
                    name: 'Manage Extra Credit Applications',
                    component: () => import( /* webpackChunkName: "institute-extra-credit-applications-list" */ '../components/Views/Institutes/ExtraCreditApplications/ExtraCreditApplications'),
                },
                {
                    path: 'all',
                    name: 'All Extra Credit Applications',
                    component: () => import( /* webpackChunkName: "institute-all-extra-credit-applications-list" */ '../components/Views/Institutes/ExtraCreditApplications/ExtraCreditApplicationsList'),
                },
            ]
        },

        {
            path: 'programmes',
            // name: 'Manage Academic Programmes & Courses',
            component: () => import( /* webpackChunkName: "programmes-and-course-home" */ '../components/Views/Institutes/ProgrammesAndCourses/ProgrammesAndCourses'),
            children: [{
                path: '',
                name: 'Institute Manage Academic Programmes',
                component: () => import( /* webpackChunkName: "mainstream-academic-programmes" */ '../components/Views/Institutes/ProgrammesAndCourses/ProgrammeList')
            },
            {
                path: "affiliate-programmes",
                name: 'Institute Manage Affiliate Academic Programmes',
                component: () => import( /* webpackChunkName: "affiliate-academic-programmes" */ '../components/Views/Institutes/ProgrammesAndCourses/AffiliateProgrammeList')
            },
            ]
        },

        {
            path: 'courses',
            component: () => import( /* webpackChunkName: "courses-home" */ '../components/Views/Institutes/Courses/CourseManagement'),
            children: [
                {
                    path: "",
                    name: 'Manage Courses',
                    component: () => import( /* webpackChunkName: "managecourse-list" */ '../components/Views/Institutes/Courses/CourseList')
                },

                {
                    path: "course-specifications",
                    name: 'Manage Course Specifications',
                    component: () => import( /* webpackChunkName: "institutes-manage-course-specs" */ '../components/Views/Institutes/Courses/CourseSpecification')
                },

                {
                    path: "credit-load-limit",
                    name: 'Manage Credit Load Limit',
                    component: () => import( /* webpackChunkName: "manage-credit-load-limit-list" */ '../components/Views/Institutes/Courses/CreditLoadLimitList')
                },
            ]

        },

        {
            path: 'users',
            component: () => import( /* webpackChunkName: "users-home" */ '../components/Views/Institutes/Users/UsersManagement.vue'),
            children: [{
                path: "",
                name: 'Manage Institute Students',
                component: () => import( /* webpackChunkName: "users-institutes-students" */ '../components/Views/Institutes/Users/StudentManagement')
            },
            {
                path: "lecturers",
                name: 'Manage Institute Lecturers',
                component: () => import( /* webpackChunkName: "users-institutes-lecturers" */ '../components/Views/Institutes/Users/LecturerManagement')
            },
            {
                path: "supporting-staff",
                name: 'Manage Institute Supporting Staff',
                component: () => import( /* webpackChunkName: "users-institutes-supporting-staff" */ '../components/Views/Institutes/Users/SupportStaffManagement'),
            },
            ]
        },

        {
            path: 'units',
            name: "Manage Institute Units",
            component: () => import( /* webpackChunkName: "institutes-units" */  '../components/Views/Institutes/Unit/Units')
        },

        {
            path: 'unit/profile',
            name: 'Unit Profile',
            component: () => import( /* webpackChunkName: "institute-unit-profile" */ '../components/Views/Institutes/Unit/UnitProfile'),
            props: true,
        },

        {
            path: 'deputy-directors',
            name: "Manage Institute Deputy Directors",
            component: () => import( /* webpackChunkName: "institutes-deputy-directors" */  '../components/Views/Institutes/DeputyDirector/DeputyDirectors')
        },

        {
            path: 'degree-categories',
            name: "Manage Institute Academic Degrees",
            component: () => import( /* webpackChunkName: "institutes-academic-degree-categories" */  '../components/Views/Institutes/AcademicDegrees/AcademicDegreeCategory')
        },
        {
        path: "graduating-list",
        name: "Institute Graduating List",
        component: () =>
            import(
                /* webpackChunkName: 'institute-graduating-list' */ "../components/Views/Institutes/GraduatingList/GraduatingList.vue"
            ),
        },

        {
            path: "good-standing-management",
            name: 'Institutes Good Standing List',
            component: () => import( /* webpackChunkName: "institute-good-standing-management" */ '../components/Views/Institutes/GoodStandings/GoodStandingList'),
        },

        {
            path: 'academic-levels',
            // name: 'Students & Academic Programmes Levels',
            component: () => import( /* webpackChunkName: "institutes-academic-levels-home" */  '../components/Views/Institutes/AcademicLevels/Levels'),
            children: [
                {
                    path: "",
                    name: 'Manage Institute Academic Programme Levels',
                    component: () => import( /* webpackChunkName: "institutes-program-academic-levels" */  '../components/Views/Institutes/AcademicLevels/AcademicProgrammeLevels'),
                },
                {
                    path: 'student-levels',
                    name: 'Manage Institute Students Academic Levels',
                    component: () => import( /* webpackChunkName: "institutes-student-academic-levels" */  '../components/Views/Institutes/AcademicLevels/StudentAcademicLevels')
                },
                {
                    path: 'students-level-progression',
                    name: 'Students Institute Academic Level Progression',
                    component: () => import( /* webpackChunkName: "institutes-student-level-progression" */  '../components/Views/Institutes/AcademicLevels/StudentAcademicLevelProgression')
                },
            ]
        },

        {
            path: 'announcements',
            component: () => import( /* webpackChunkName: "institutes-manage-announcement-list" */ '../components/Views/Institutes/Announcements/AnnouncementsList'),
            name: 'Manage Institute Announcement',
        },
        {
            path: 'matric-no-template',
            component: () => import( /* webpackChunkName: "institutes-matric-no-template-home" */ '../components/Views/Institutes/MatricNumber/MatricNumberTemplate'),
            children: [{
                path: '',
                name: 'Manage Institute Matric Template',
                component: () => import( /* webpackChunkName: "institutes-matric-template-list" */ '../components/Views/Institutes/MatricNumber/MatricNumberTemplateList')
            },
            {
                path: 'generate-matric-no',
                name: 'Generate Institute Matric Number',
                component: () => import( /* webpackChunkName: "institutes-generate-matric-no" */ '../components/Views/Institutes/MatricNumber/GenerateMatricNumber')
            },
            {
                path: 'matric-number-buffer',
                name: 'Matric Institute Number Buffer',
                component: () => import( /* webpackChunkName: "institutes-matric-number-buffer" */ '../components/Views/Institutes/MatricNumber/MatricNumberExemptionList')
            },
            {
                path: 'matric-number-list',
                name: 'Matric Institute Number List',
                component: () => import( /* webpackChunkName: "institutes-matric-number-list" */ '../components/Views/Institutes/MatricNumber/MatriculatedList')
            },
            ]
        },

        {
            path: 'students-registration-list',
            component: () => import( /* webpackChunkName: "institutes-students-registration-list-home" */ '../components/Views/Institutes/StudentsRegistrationList/StudentsRegistration'),
            children: [
                {
                    path: '',
                    name: 'Manage Institute Students Registration',
                    component: () => import( /* webpackChunkName: "institutes-students-registration-list" */ '../components/Views/Institutes/StudentsRegistrationList/StudentsRegistrationList')
                },
                {
                    path: 'submission-list',
                    name: 'View Institute Registration Submission List',
                    component: () => import( /* webpackChunkName: "institutes-students-registration-submission-list" */ '../components/Views/Institutes/StudentsRegistrationList/StudentsRegistrationSubmissionList')
                },
                {
                    path: 'enrollment-list',
                    name: 'View Institute Course Enrollment List',
                    component: () => import( /* webpackChunkName: "institutes-students-courses-enrollment-list" */ '../components/Views/Institutes/StudentsRegistrationList/StudentsCoursesEnrollmentList')
                },
                {
                    path: 'management',
                    name: 'Student Courses Registration Management',
                    component: () => import( /* webpackChunkName: "students-courses-reg-management" */ '../components/Views/Institutes/StudentsRegistrationList/StudentsCoursesRegistrationManagement'),
                },
            ]
        },

        {
            path: 'graduation-management',
            component: () => import( /* webpackChunkName: "institutes-graduation-management" */ '../components/Views/Institutes/GraduationList/GraduationManagement'),
            children: [

                {
                    path: "list",
                    name: 'Institute Graduation List Admin Panel',
                    component: () => import( /* webpackChunkName: "institutes-graduation-list" */ '../components/Views/Institutes/GraduationList/GraduationList'),
                },
                {
                    path: "graduated-students",
                    name: 'Institute Graduated Students Admin Panel',
                    component: () => import(/* webpackChunkName: 'institutes-graduated-students' */ '../components/Views/Institutes/GraduationList/GraduatedStudentsList'),
                }
            ]
        },
    ]

    },
{
   //-------------------routings to the institute user management pages-----------------------//
    path: "/institute/users",
    name: "Institute Users Management",
    component: () =>
        import( /* webpackChunkName: 'institute-user' */ "../components/Views/Institutes/Users/Dashboard.vue" ),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkSuperAdminOrDirectorRole ,
    children: [
        {
            path: "users-dashboard",
            name: "Institute User Dashboard",
            component: () =>
                import(
                        /* webpackChunkName: 'institute-user-home' */ "../components/Views/Institutes/Users/Overview.vue"
                ),
        },

        {
            path: "users-management",
            component: () =>
                import(
                        /* webpackChunkName: 'institute-users-management-home' */ "../components/Views/Institutes/Users/UsersManagement.vue"
                ),
            children: [
                {
                    path: "",
                    name: 'Institute Manage Students',
                    component: () => import( /* webpackChunkName: "institute-users-students" */ '../components/Views/Institutes/Users/StudentManagement.vue')
                },
                {
                    path: "lecturers",
                    name: 'Institute Manage Lecturers',
                    component: () => import( /* webpackChunkName: "institute-users-lecturers" */ '../components/Views/Institutes/Users/LecturerManagement.vue')
                },
                {
                    path: "supporting-staff",
                    name: 'Institute Manage Supporting Staff',
                    component: () => import( /* webpackChunkName: "institute-users-supporting-staff" */ '../components/Views/Institutes/Users/SupportStaffManagement.vue'),
                },
                {
                    path: "all-students",
                    name: 'Institute Manage All Institution Students',
                    component: () => import( /* webpackChunkName: "institute-all-students" */ '../components/Views/Institutes/Users/AllStudentsManagement.vue'),
                },
                {
                    path: "students-data",
                    name: 'Manage Active Institute Students Data',
                    component: () => import( /* webpackChunkName: "institute-students-data" */ '../components/Views/Institutes/Users/StudentDataManagement.vue'),
                },
            ],
        },
]
},

{ //-------------------routings to the institute grading system pages-----------------------//
    path: '/institute/grading-system',
    name: 'Institute Grading System',
    component: () => import( /* webpackChunkName: 'institute-grading-system' */ '../components/Views/Institutes/GradingSystem/Dashboard.vue'),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkSuperAdminOrDirectorRole,
    children: [
        {
            path: 'grading-system-dashboard',
            name: 'Institute Grading System Dashboard',
            component: () => import( /* webpackChunkName: 'institute-grading-home' */ '../components/Views/Institutes/GradingSystem/GradingOverview.vue'),
        },
        {
            path: "grade-profiles",
            name: 'Institute Manage Grade Profiles',
            component: () => import( /* webpackChunkName: "institute-grade-profiles" */ '../components/Views/Institutes/GradingSystem/GradeProfiles'),
        },
        {
            path: "grade-profiles-allocation",
            name: 'Institute Manage Grade Profiles Allocations',
            component: () => import( /* webpackChunkName: "institute-grade-profiles-allocation" */ '../components/Views/Institutes/GradingSystem/GradeProfilesAllocations'),
        },
        {
            path: "grade-list",
            name: 'Institute Manage Grade List',
            component: () => import( /* webpackChunkName: "institute-grade-lists" */ '../components/Views/Institutes/GradingSystem/GradeList'),
        },
        {
            path: "assessment-score",
            name: 'Institute Assessment Score Upload',
            component: () => import( /* webpackChunkName: "institute-assessment-score" */ '../components/Views/Institutes/Assessment/AssessmentScore'),
        },
        {
            path: 'course-publications',
            name: 'Institute Course Publications',
            component: () => import( /* webpackChunkName: 'institute-course-publication' */ '../components/Views/Institutes/GradingSystem/CoursePublications')
        },
        {
            path: "grade-point-average-profiles",
            name: 'Institute Manage Grade Point Average Profiles',
            component: () => import( /* webpackChunkName: "institute-grade-point-average-profiles" */ '../components/Views/Institutes/GradingSystem/GradePointAverageProfiles'),
        },
        {
            path: "degree-class",
            name: 'Institute Manage Degree Class List',
            component: () => import( /* webpackChunkName: "institute-degree-class" */ '../components/Views/Institutes/GradingSystem/DegreeClass'),
        },
        {
            path: "grade-point-average-profiles-allocation",
            component: () => import( /* webpackChunkName: "institute-gpa-profile-allocation-home" */ '../components/Views/Institutes/GradingSystem/GradePointProfileAllocation/GradePointProfileAllocationsHome'),
            //props: true,
            children: [{
                path: "",
                name: 'Institute Default Grade Point Average Profiles Allocations',
                component: () => import( /* webpackChunkName: "institute-default-gpa-profile-allocation" */ '../components/Views/Institutes/GradingSystem/GradePointProfileAllocation/DefaultGradePointAverageProfilesAllocations')
            },
            {
                path: "sessional-grade-point-average-profiles-allocation",
                name: 'Institute Sessional Grade Point Average Profiles Allocations',
                component: () => import( /* webpackChunkName: "institute-sessional-grade-point-average-profiles-allocation" */ '../components/Views/Institutes/GradingSystem/GradePointProfileAllocation/GradePointAverageProfilesAllocations'),
            },
            ]
        },
    ]

},

{//-------------------routings to the institute admissions pages-----------------------//
    path: '/institute/admissions',
    beforeEnter: checkSuperAdminOrDirectorRole,
    component: () => import( /* webpackChunkName: 'institute-admissions' */ '../components/Views/Institutes/Admissions/Dashboard'),
    props: true,
    children: [
        {
            path: 'institute-admissions-dashboard',
            name: 'Institute Admissions Dashboard',
            component: () => import( /* webpackChunkName: 'institute-admissions-home' */ '../components/Views/Institutes/Admissions/Overview'),
        },
        {
            path: 'candidates',
            component: () => import( /* webpackChunkName: 'institute-candidates-list' */ '../components/Views/Institutes/Admissions/Candidates'),
            name: 'Institute Admission Candidates',
        },
        // {
        //     path: 'all-candidates',
        //     component: () => import( /* webpackChunkName: 'institute-all-candidates-list' */ '../components/Views/Institutes/Admissions/AllCandidates'),
        //     name: 'Institute All Admission Candidates',
        // },
        {
            path: 'entry-modes',
            component: () => import( /* webpackChunkName: 'institute-modes-and-catchments-list' */ '../components/Views/Institutes/Admissions/ModesHome'),
            children: [{
                path: "",
                name: 'Institute Modes of Entry',
                component: () => import( /* webpackChunkName: 'institute-modes-of-entry-list' */ '../components/Views/Institutes/Admissions/ModesOfEntry')
            },
            {
                path: "catchment-states",
                name: 'Institute Cathcment States',
                component: () => import( /* webpackChunkName: 'institute-cathcment-states-list' */ '../components/Views/Institutes/Admissions/Catchments'),
            },
            ]
        },
        {
            path: 'exam-bodies',
            component: () => import( /* webpackChunkName: 'institute-exam-bodies-and-type' */ '../components/Views/Institutes/Admissions/ExamsHome'),
            children: [{
                path: "",
                name: 'Institute Approved Examination Bodies',
                component: () => import( /* webpackChunkName: 'institute-exam-bodies-list' */ '../components/Views/Institutes/Admissions/ExamBodies')
            },
            {
                path: "exam-types",
                name: 'Institute Examination Types',
                component: () => import( /* webpackChunkName: 'institute-exam-types-list' */ '../components/Views/Institutes/Admissions/ExamTypes'),
            },
            ]
        },
        {
            path: 'post-utme-exams',
            component: () => import( /* webpackChunkName: 'institute-exam-cities-and-centres' */ '../components/Views/Institutes/Admissions/PostUtmeHome'),
            children: [{
                path: "",
                name: 'Institute Post UTME Examination',
                component: () => import( /* webpackChunkName: 'institute-post-utme-exams-list' */ '../components/Views/Institutes/Admissions/PostUtmeExams')
            },
            {
                path: "exam-cities",
                name: 'Institute Examination Cities',
                component: () => import( /* webpackChunkName: 'institute-exam-cities-list' */ '../components/Views/Institutes/Admissions/ExamCities'),
            },
            {
                path: "exam-centres",
                name: 'Institute Examination Centres',
                component: () => import( /* webpackChunkName: 'institute-exam-centres-list' */ '../components/Views/Institutes/Admissions/ExamCentres'),
            },
            {
                path: "batches",
                name: 'Institute Post UTME Examination Batches',
                component: () => import( /* webpackChunkName: 'institute-post-utme-exam-batches-list' */ '../components/Views/Institutes/Admissions/PostUtmeExamBatches'),
            },
            {
                path: "post-utme-exam/batch",
                name: "Institute Post Utme Exam Batch",
                component: () =>
                    import(
                            /* webpackChunkName: 'institute-post-utme-exam-batch' */ "../components/Views/Institutes/Admissions/PostUtmeExamBatch"
                    ),
                props: true,
            },
            {
                path: "allocations",
                name: 'Institute Post UTME Examination Allocations',
                component: () => import( /* webpackChunkName: 'institute-post-utme-exam-allocations-list' */ '../components/Views/Institutes/Admissions/PostUtmeExamAllocations'),
            },
            ]
        },
        {
            path: 'candidate-approvals',
            component: () => import(/* webpackChunkName: 'institute-candidate-approvals' */ '../components/Views/Institutes/Admissions/AdmitCandidates/AdmitHome'),
            children: [
                {
                    path: '',
                    name: 'Manage Approved Candidates',
                    component: () => import( /* webpackChunkName: "institute-candidate-approvals-list" */ '../components/Views/Institutes/Admissions/AdmitCandidates/ApprovedCandidates'),
                },
                {
                    path: 'all-candidates',
                    name: 'Manage All Candidate Recommendations',
                    component: () => import( /* webpackChunkName: "institute-all-candidate-approvals-list" */ '../components/Views/Institutes/Admissions/AdmitCandidates/AllCandidates'),
                },
                {
                    path: "admissions-list",
                    name: 'Institute Upload Admission List',
                    component: () => import( /* webpackChunkName: 'institute-admissions-list' */ '../components/Views/Institutes/Admissions/AdmitCandidates/UploadAdmissionList'),
                },
            ]
        },

        {
            path: 'grades',
            name: "Institute O'Level Grades",
            component: () => import( /* webpackChunkName: 'institute-olevel-grades-list' */ '../components/Views/Institutes/Admissions/Grades'),
        },

        {
            path: "grades/a_level",
            name: "Institute A'Level Grades",
            component: () =>
                import(
                        /* webpackChunkName: 'alevel-grades-list' */ "../components/Views/Institutes/Admissions/AGrades"
                ),
        },

        {
            path: "grades/degree",
            name: "Institute Degree / Diploma Grades",
            component: () =>
                import(
                        /* webpackChunkName: 'degree-grades-list' */ "../components/Views/Institutes/Admissions/DegreeGrades"
                ),
        },
        {
            path: 'admission-acceptance-deadlines',
            name: "Institute Admission Acceptance Deadlines",
            component: () => import( /* webpackChunkName: 'institute-admission-acceptance-deadlines' */ '../components/Views/Institutes/Admissions/AdmissionAcceptanceDeadlines'),
        },

        {
            path: 'admission-rounds',
            name: "Institute Admissions Rounds",
            component: () => import( /* webpackChunkName: 'institute-admissions-rounds-list' */ '../components/Views/Institutes/Admissions/AdmissionRounds'),
        },

         {
            path: 'past-papers',
            name: "Institute Past Papers",
            component: () => import( /* webpackChunkName: 'institute-past-papers-list' */ '../components/Views/Institutes/Admissions/PastPapers'),
        },
        // {
        //     path: 'advertised-programmes',
        //     name: "Institute Advertised Programmes",
        //     component: () => import( /* webpackChunkName: 'institute-advertised-programmes-list' */ '../components/Views/Institutes/Admissions/Programmes'),
        // },
        {
            path: "advertised-programmes-units",
            name: "Institute Advertised Programmes Units",
            component: () =>
                import(/* webpackChunkName: 'institute-advertised-programmes-units-list' */ "../components/Views/Institutes/Admissions/Units.vue"),
        },
        {
            path: "advertised-programmes",
            name: "Institute Advertised Programmes",
            props: true,
            component: () =>
                import(
                        /* webpackChunkName: 'institute-advertised-programmes-list' */ "../components/Views/Institutes/Admissions/AdvertisedProgrammes.vue"
                ),
        },
        {
            path: "admission-clearance-units",
            name: "Institute Admission Clearance Units",
            component: () =>
                import(/* webpackChunkName: 'institute-admissions-clearance-unit-list' */ "../components/Views/Institutes/Admissions/AdmissionClearanceUnits"),
        },
        {
            path: 'admission-clearance',
            name: "Institute Admission Clearance",
            props: true,
            component: () => import( /* webpackChunkName: 'institute-admission-clearance' */ '../components/Views/Institutes/Admissions/ProgrammesWithAdmittedCandidates'),
        },
        {
            path: 'requirements/general',
            name: "Institute General Admission Requirements",
            component: () => import( /* webpackChunkName: 'institute-institutional-general-admission-requirements' */ '../components/Views/Institutes/Admissions/GeneralRequirements'),
            props: true
        },
        {
            path: 'requirements/programme',
            name: "Institute Programme Admission Requirements",
            component: () => import( /* webpackChunkName: 'institute-programme-admission-requirements' */ '../components/Views/Institutes/Admissions/ProgrammeRequirements'),
            props: true
        },
        {
            path: 'programmes/candidates',
            name: "Institute Programme Candidates",
            component: () => import( /* webpackChunkName: 'institute-programme-candidates-list' */ '../components/Views/Institutes/Admissions/ProgrammeCandidates'),
            props: true
        },

        {
            path: 'clearance-candidates',
            name: "Institute Clearance Candidates",
            component: () => import( /* webpackChunkName: 'institute-clearance-candidates-list' */ '../components/Views/Institutes/Admissions/ClearanceCandidates'),
            props: true
        },

        {
            path: 'programmes/candidates/application-details',
            name: "Institute Candidate's Application Details",
            component: () => import( /* webpackChunkName: 'institute-candidates-application-details' */ '../components/Views/Institutes/Admissions/CandidateApplicationDetails'),
            props: true
        },

        {
            path: 'clearance-candidates/clearance-documents',
            name: "Institute Candidate's Clearance Documents",
            component: () => import( /* webpackChunkName: 'institute-candidates-application-clearance-details' */ '../components/Views/Institutes/Admissions/CandidateClearanceDocuments'),
            props: true
        },
        {
            path: "admissions-list",
            name: 'Institute Upload Admission List',
            component: () => import( /* webpackChunkName: 'institute-admissions-list' */ '../components/Views/Institutes/Admissions/UploadAdmissionList'),
        },
    ]
},

{
    //-------------------routings to the finance pages-----------------------//
    path: "/institute/finance",
    name: "Institute Finance",
    beforeEnter: checkSuperAdminOrDirectorRole,
    props: true,
    component: () =>
        import(
            /* webpackChunkName: 'finance' */ "../components/Views/Institutes/Finance/Dashboard"
        ),
    meta: { authenticatedUserOnly: true },
    children: [
        {
            path: "finance-dashboard",
            name: "Institute Finance Dashboard",
            component: () =>
                import(
                    /* webpackChunkName: 'finance-home' */ "../components/Views/Institutes/Finance/FinanceOverview"
                ),
        },
        {
            path: "payments",
            name: "Institute Payments",
            component: () =>
                import(
                    /* webpackChunkName: 'payments-lists' */ "../components/Views/Institutes/Finance/Payments"
                ),
        },
        {
            path: 'charges',
            name: "Institute Admission Processing Charges",
            component: () => import( /* webpackChunkName: 'institute-admission-processing-charges' */ '../components/Views/Institutes/Finance/ProcessingCharges'),
        },
        {
            path: 'convocation-charges',
            name: "Institute Convocation Charges",
            component: () => import( /* webpackChunkName: 'institute-convocation-charges' */ '../components/Views/Institutes/Finance/ConvocationCharges'),
        },
        {
            path: 'invoices',
            component: () => import( /* webpackChunkName: "institute-invoice-management" */ '../components/Views/Institutes/Finance/InvoiceManagement'),
            children: [

                {
                    path: "",
                    name: "Institute Invoices",
                    component: () =>
                        import(
                                /* webpackChunkName: 'institute-invoice-lists' */ "../components/Views/Institutes/Finance/Invoices"
                        ),
                },
                {
                    path: 'invoice-gateways',
                    name: "Manage Institute Invoice Gateways",
                    component: () => import( /* webpackChunkName: 'institute-invoice-gateways' */ '../components/Views/Institutes/Finance/InvoiceGateway'),
                },
            ]
        },
        {
            path: "fees",
            component: () => import( /* webpackChunkName: "fees" */ '../components/Views/Institutes/Finance/FeesAndFeesAllocation'),
            //props: true,
            children: [
            // {
            //     path: "",
            //     name: 'Institute Fee Items',
            //     component: () => import( /* webpackChunkName: "institute-fee-items" */ '../components/Views/Institutes/Finance/Feeplans')
            // },
            {
                path: "manage",
                // name: 'Manage Fee Item Groups / Fee Items',
                component: () => import( /* webpackChunkName: "manage-fee-items" */ '../components/Views/Institutes/Finance/ManageFeeItemAndGroup'),
                children: [
                    {
                        path: "fee-items",
                        name: 'Institute Fee Items',
                        component: () => import( /* webpackChunkName: "fee-items" */ '../components/Views/Institutes/Finance/FeeItems')
                    },
                    {
                        path: "",
                        name: 'Institute Fee Item Group',
                        component: () => import( /* webpackChunkName: "fee-heads" */ '../components/Views/Institutes/Finance/FeeHeads')
                    },
                ]
            },
            {
                path: "",
                name: 'Institute Fee Plans',
                component: () => import( /* webpackChunkName: "institute-fee-plans" */ '../components/Views/Institutes/Finance/Feeplans')
            },
            {
                path: "fee-plan-allocation",
                name: 'Institute Fee Plan Allocation',
                component: () => import( /* webpackChunkName: "institute-fee-plan-allocation" */ '../components/Views/Institutes/Finance/FeePlanAllocation')
            },
            ]
        },
        {
            path: "rebates",
            component: () => import( /* webpackChunkName: "institute-rebates-home" */ '../components/Views/Institutes/Finance/Rebates/RebatesHome'),
            //props: true,
            children: [{
                path: "",
                name: 'Institute Rebates',
                component: () => import( /* webpackChunkName: "institute-rebates" */ '../components/Views/Institutes/Finance/Rebates/Rebates'),
            },
            {
                path: "rebates-grant",
                name: 'Institute Rebates Grant',
                component: () => import( /* webpackChunkName: "institute-rebates-grant" */ '../components/Views/Institutes/Finance/Rebates/RebateGrants'),
            },

            {
                path: "scholarships",
                name: 'Institute Scholarships',
                component: () => import( /* webpackChunkName: "institute-scholarships" */ '../components/Views/Institutes/Finance/Rebates/Scholarships'),
            },
            {
                path: "scholarship-grants",
                name: 'Institute Scholarships Grant',
                component: () => import( /* webpackChunkName: "institute-scholarship-grant" */ '../components/Views/Institutes/Finance/Rebates/ScholarshipGrants'),
            },
            ]
        },
        {
            path: 'fee-plan-items',
            name: "Institute Fee Plan Items",
            component: () => import( /* webpackChunkName: 'institute-fee-plan-items' */ '../components/Views/Institutes/Finance/FeePlanItems'),
            props: true,
        },
        {
            path: "bank-accounts",
            name: "Institute Bank Accounts",
            component: () =>
                import(
                    /* webpackChunkName: 'institute-bank-accounts' */ "../components/Views/Institutes/Finance/BankAccounts"
                ),
        },
        {
            path: 'transaction-validation',
            name: 'Institute Students Transactions Validation',
            component: () => import(/* webpackChunkName: 'institute-transaction-validation' */ '../components/Views/Institutes/Finance/PaymentsValidation'),
        },

        {
            path: "suplementary-fee",
            //  name: "Fees",
            component: () => import( /* webpackChunkName: "supplementary-fees" */ '../components/Views/Institutes/Finance/SupplementaryFees/SupplementaryFeesAndAllocation'),
            //props: true,
            children: [
            {
                path: "",
                name: 'Institute Supplementary Fee',
                component: () => import( /* webpackChunkName: "supplementary-fees" */ '../components/Views/Institutes/Finance/SupplementaryFees/SupplementaryFee')
            },
            {
                path: "allocations",
                name: 'Institute Supplementary Fee Allocation',
                component: () => import( /* webpackChunkName: "supplementary-fee-allocation" */ '../components/Views/Institutes/Finance/SupplementaryFees/SupplementaryFeeAllocation')
            },
            ]
        },
        {
            path: 'hostel-pool-charges',
            name: "Manage Insitute Hostel Pool",
            component: () => import( /* webpackChunkName: 'insitute-hostel-pool-charges' */ '../components/Views/Institutes/Finance/HostelPoolCharges'),
        },
        {
            path: 'supplementary-fee/details',
            name: "Institute Supplementary Fee Details",
            component: () => import( /* webpackChunkName: 'supplementary-fee-details' */ '../components/Views/Institutes/Finance/SupplementaryFees/SupplementaryFeeDetails'),
            props: true,
        },
    ],
},

{ //-------------------routings to the curriculum management pages-----------------------//
    path: '/institute/curriculum',
    name: 'Institute Admin Curriculum',
    component: () => import( /* webpackChunkName: 'institute-admin-curriculum' */ '../components/Views/Institutes/CurriculumManagement/Dashboard'),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkSuperAdminOrDirectorRole,
    children: [

        {
            path: 'curriculum-dashboard',
            name: 'Institute Curriculum Management Dashboard',
            component: () => import( /* webpackChunkName: 'institute-curriculum-dashboard' */ '../components/Views/Institutes/CurriculumManagement/CurriculumOverview'),
        },
        {
            path: "curriculum-management",
            name: 'Institute Manage Curriculums',
            component: () => import( /* webpackChunkName: "institute-curriculum-management" */ '../components/Views/Institutes/CurriculumManagement/CurriculumManagement'),
        },
        {
            path: "/manage/:id",
            name: "Institute Curriculum Management Admin",
            component: () =>
                import(
                    /* webpackChunkName: 'manage' */ "../components/Views/Department/Curriculum/CurriculumManagement"
                ),
            props: true,
            mode: "params",
        },
        {
            path: "curriculums-allocations",
            name: 'Institute Curriculum Allocations Admin',
            component: () => import( /* webpackChunkName: "institute-curriculums-allocations" */ '../components/Views/Institutes/CurriculumManagement/CurriculumAllocations'),
        },
    ]
},

{ //-------------------routings to the grading system pages-----------------------//
    path: '/grading-system',
    name: 'Grading System',
    component: () => import( /* webpackChunkName: 'grading-system' */ '../components/Views/Admin/GradingSystem/Dashboard'),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkSuperAdminRole,
    children: [
        {
            path: 'grading-system-dashboard',
            name: 'Grading System Dashboard',
            component: () => import( /* webpackChunkName: 'grading-home' */ '../components/Views/Admin/GradingSystem/GradingOverview'),
        },
        // {
        //     path: "grade-profiles",
        //     name: 'Manage Grade Profiles',
        //     component: () => import( /* webpackChunkName: "grade-profiles" */ '../components/Views/Admin/GradingSystem/GradeProfiles'),
        // },
        {
            path: "grade-profiles-allocation",
            name: 'Manage Grade Profiles Allocations',
            component: () => import( /* webpackChunkName: "grade-profiles-allocation" */ '../components/Views/Admin/GradingSystem/GradeProfilesAllocations'),
        },
        {
            path: "grade-list",
            name: 'Manage Grade List',
            component: () => import( /* webpackChunkName: "grade-lists" */ '../components/Views/Admin/GradingSystem/GradeList'),
        },
        {
            path: "grade-profile-exception-list",
            name: 'Manage Grade Profile Exception List',
            component: () => import( /* webpackChunkName: "grade-profile-exception-lists" */ '../components/Views/Admin/GradingSystem/GradProfileExceptionList'),
        },
        {
            path: "assessment_policy",
            name: 'Manage Assessment Policy',
            component: () => import( /* webpackChunkName: "assessment-policy" */ '../components/Views/Admin/Assessment/AssessmentWithPolicy'),
        },
        {
            path: "assessment-score",
            name: 'Assessment Score Upload',
            component: () => import( /* webpackChunkName: "assessment-score" */ '../components/Views/Admin/Assessment/AssessmentScore'),
        },
        {
            path: 'add-assessment/:course_id/:session_id/:semester_id',
            component: () => import(/* webpackChunkName: 'admin-add-assessment' */ '../components/Views/Admin/Assessment/AddAssessment'),
            name: "Admin Add Assessment"
        },
        {
            path: 'course-publications',
            name: 'Course Publications',
            component: () => import( /* webpackChunkName: 'course-publication' */ '../components/Views/Admin/GradingSystem/CoursePublications')
        },
        {
            path: "grade-point-average-profiles",
            name: 'Manage Grade Point Average Profiles',
            component: () => import( /* webpackChunkName: "grade-point-average-profiles" */ '../components/Views/Admin/GradingSystem/GradePointAverageProfiles'),
        },
        {
            path: "grade-lock",
            name: 'Toggle Grade Lock',
            component: () => import( /* webpackChunkName: "grade-lock" */ '../components/Views/Admin/GradingSystem/GradeLock'),
        },
        {
            path: "grade-edit-request",
            name: 'Grade Edit Request',
            component: () => import( /* webpackChunkName: "grade-lock" */ '../components/Views/Admin/GradingSystem/GradeEditRequest'),
        },
        {
            path: 'students-result-list',
            component: () => import( /* webpackChunkName: "students-result-list-home" */ '../components/Views/Admin/GradingSystem/StudentsResult'),
            children: [
                {
                    path: '',
                    name: 'Manage Students Result',
                    component: () => import( /* webpackChunkName: "students-result-list" */ '../components/Views/Admin/GradingSystem/Results')
                },
                {
                    path: 'cummulative-result-list',
                    name: 'View Cummulative Result',
                    component: () => import( /* webpackChunkName: "cummulative-result-list" */ '../components/Views/Admin/GradingSystem/CummulativeResult.vue')
                },
                {
                    path: 'spreadsheet-list',
                    name: 'View Student Result Spreadsheet List',
                    component: () => import( /* webpackChunkName: "spreadsheet-list" */ '../components/Views/Admin/GradingSystem/ResultSpreadSheet')
                },
                {
                    path: 'results-spreadsheet',
                    component: () => import( /* webpackChunkName: "results-spreadsheet" */ '../components/Views/Admin/GradingSystem/StudentResultsSpreadSheet'),
                    name: 'Admin Student Results Spread Sheet',
                },
            ]
        },
        {
            path: "degree-class",
            name: 'Manage Degree Class List',
            component: () => import( /* webpackChunkName: "degree-class" */ '../components/Views/Admin/GradingSystem/DegreeClass'),
        },

        {
            path: "grade-point-average-profiles-allocation",
            component: () => import( /* webpackChunkName: "gpa-profile-allocation-home" */ '../components/Views/Admin/GradingSystem/GradePointProfileAllocation/GradePointProfileAllocationsHome'),
            //props: true,
            children: [{
                path: "",
                name: 'Default Grade Point Average Profiles Allocations',
                component: () => import( /* webpackChunkName: "default-gpa-profile-allocation" */ '../components/Views/Admin/GradingSystem/GradePointProfileAllocation/DefaultGradePointAverageProfilesAllocations')
            },
            {
                path: "sessional-grade-point-average-profiles-allocation",
                name: 'Sessional Grade Point Average Profiles Allocations',
                component: () => import( /* webpackChunkName: "sessional-grade-point-average-profiles-allocation" */ '../components/Views/Admin/GradingSystem/GradePointProfileAllocation/GradePointAverageProfilesAllocations'),
            },
            ]
        },

        {
            path: "grade-profiles",
            component: () => import( /* webpackChunkName: "grade-profile-home" */ '../components/Views/Admin/GradingSystem/GradeProfile/GradeProfileHome.vue'),
            children: [{
                path: "",
                name: 'Grade Profiles',
                component: () => import( /* webpackChunkName: "grade-profiles" */ '../components/Views/Admin/GradingSystem/GradeProfile/GradeProfiles.vue')
            },
            {
                path: "special-grade-profiles",
                name: 'Special Grade Profiles',
                component: () => import( /* webpackChunkName: "special-grade-profiles" */ '../components/Views/Admin/GradingSystem/GradeProfile/SpecialGradeProfiles.vue'),
            },
            ]
        },

        {
            path: "course-result-list",
            name: 'Manage Course Result List',
            component: () => import( /* webpackChunkName: "course-result-list" */ '../components/Views/Admin/GradingSystem/CourseResultList.vue'),
        },
    ]
},

{
    path: '/lecturer-assessment',
    name: 'Lecturer Assessment',
    component: () => import(/* webpackChunkName: 'lecturer-assessment' */ '../components/Views/Admin/LecturerAssessment/Dashboard'),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkSuperAdminRole,
    children: [
        {
            path: 'dashboard',
            name: 'Lecturer Assessment Dashboard',
            component: () => import(/* webpackChunkName: 'lecturer-assessment-home' */ '../components/Views/Admin/LecturerAssessment/LecturerAssessmentOverview'),
        },
      {
        path: '',
        name: 'Lecturer Assessment Add Question (Default)',
        component: () => import(/* webpackChunkName: 'lecturer-assessment-add-question' */ '../components/Views/Admin/LecturerAssessment/AddQuestion'),
      },
      {
        path: "add-question",
        name: 'Lecturer Assessment Add Question',
        component: () => import(/* webpackChunkName: 'lecturer-assessment-add-question' */ '../components/Views/Admin/LecturerAssessment/AddQuestion'),
      },
      {
        path: "questionnaire-question",
        name: 'Lecturer Assessment Add Questionnaire Question',
        component: () => import(/* webpackChunkName: 'lecturer-assessment-questionnaire-question' */ '../components/Views/Admin/LecturerAssessment/QuestionnaireQuestion'),
      },
      {
        path: "questionnaire",
        name: 'Lecturer Assessment Add Questionnaire',
        component: () => import(/* webpackChunkName: 'lecturer-assessment-questionnaire' */ '../components/Views/Admin/LecturerAssessment/Questionnaire'),
      },
      {
        path: "questionnaire-allocation",
        name: 'Lecturer Assessment Add Questionnaire Allocation',
        component: () => import(/* webpackChunkName: 'lecturer-assessment-questionnaire-allocation' */ '../components/Views/Admin/LecturerAssessment/QuestionnaireAllocation'),
      },
      {
        path: "questionnaire-allocation/response/:allocation_id",
        name: 'Lecturer Assessment Response',
        component: () => import(/* webpackChunkName: 'lecturer-assessment-questionnaire-response' */ '../components/Views/Admin/LecturerAssessment/QuestionnaireResponse'),
      },
    ]
},

{
    path: "/admissions/programme/requirements",
    name: "Programme Requirements",
    beforeEnter: checkSuperAdminRole,
    component: () =>
        import(
                /* webpackChunkName: 'programme-requirements' */ "../components/Views/Admissions/ProgrammeRequirements"
        ),
    props: true,
},
{
    //-------------------routings to the pre-admission screening pages------//beforeEnter: checkAdmissionOfficerRole,-------------------//
    path: "/admissions",
    name: "Admissions",
    component: () =>
        import(
                /* webpackChunkName: 'admissions' */ "../components/Views/Admissions/Dashboard"
        ),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkAdmissionsDashboardPermission,
    //beforeEnter: checkSuperAdminRole,
    children: [
        {
            path: "admissions-dashboard",
            name: "Admissions Dashboard",
            component: () =>
                import(
                        /* webpackChunkName: 'admissions-home' */ "../components/Views/Admissions/Overview"
                ),
        },
        {
            path: "candidates",
            name: "Admission Candidates",
            component: () =>
                import(
                        /* webpackChunkName: 'candidates-list' */ "../components/Views/Admissions/Candidates.vue"
                ),
        },
        {
            path: "entry-modes",
            component: () =>
                import(
                        /* webpackChunkName: 'modes-and-catchments-list' */ "../components/Views/Admissions/ModesHome"
                ),
            children: [
                {
                    path: "",
                    name: "Modes of Entry",
                    component: () =>
                        import(
                                /* webpackChunkName: 'modes-of-entry-list' */ "../components/Views/Admissions/ModesOfEntry"
                        ),
                },
                {
                    path: "catchment-states",
                    name: "Cathcment States",
                    component: () =>
                        import(
                                /* webpackChunkName: 'cathcment-states-list' */ "../components/Views/Admissions/Catchments"
                        ),
                },
            ],
        },
        {
            path: "exam-bodies",
            component: () =>
                import(
                        /* webpackChunkName: 'exam-bodies-and-type' */ "../components/Views/Admissions/ExamsHome"
                ),
            children: [
                {
                    path: "",
                    name: "Approved Examination Bodies",
                    component: () =>
                        import(
                                /* webpackChunkName: 'exam-bodies-list' */ "../components/Views/Admissions/ExamBodies"
                        ),
                },
                {
                    path: "exam-types",
                    name: "Examination Types",
                    component: () =>
                        import(
                                /* webpackChunkName: 'exam-types-list' */ "../components/Views/Admissions/ExamTypes"
                        ),
                },
            ],
        },

        {
            path: 'post-utme-exams',
            component: () => import( /* webpackChunkName: 'exam-cities-and-centres' */ '../components/Views/Admissions/PostUtmeHome'),
            children: [{
                path: "",
                name: 'Post UTME Examination',
                component: () => import( /* webpackChunkName: 'post-utme-exams-list' */ '../components/Views/Admissions/PostUtmeExams')
            },
            {
                path: "exam-cities",
                name: 'Examination Cities',
                component: () => import( /* webpackChunkName: 'exam-cities-list' */ '../components/Views/Admissions/ExamCities'),
            },
            {
                path: "exam-centres",
                name: 'Examination Centres',
                component: () => import( /* webpackChunkName: 'exam-centres-list' */ '../components/Views/Admissions/ExamCentres'),
            },
            {
                path: "batches",
                name: 'Post UTME Examination Batches',
                component: () => import( /* webpackChunkName: 'post-utme-exam-batches-list' */ '../components/Views/Admissions/PostUtmeExamBatches'),
            },
            {
                path: "post-utme-exam/batch",
                name: "Post Utme Exam Batch",
                component: () =>
                    import(
                            /* webpackChunkName: 'post-utme-exam-batch' */ "../components/Views/Admissions/PostUtmeExamBatch"
                    ),
                props: true,
            },
            {
                path: "allocations",
                name: 'Post UTME Examination Allocations',
                component: () => import( /* webpackChunkName: 'post-utme-exam-allocations-list' */ '../components/Views/Admissions/PostUtmeExamAllocations'),
            },
            ]
        },

        {
            path: "grades",
            name: "O'Level Grades",
            component: () =>
                import(
                        /* webpackChunkName: 'olevel-grades-list' */ "../components/Views/Admissions/Grades"
                ),
        },
        {
            path: "grades/a_level",
            name: "A'Level Grades",
            component: () =>
                import(
                        /* webpackChunkName: 'alevel-grades-list' */ "../components/Views/Admissions/AGrades"
                ),
        },

        {
            path: "grades/degree",
            name: "Degree / Diploma Grades",
            component: () =>
                import(
                        /* webpackChunkName: 'degree-grades-list' */ "../components/Views/Admissions/DegreeGrades"
                ),
        },
        {
            path: "grades/kcse",
            name: "KCSE Grades",
            component: () =>
                import(
                        /* webpackChunkName: 'degree-grades-list' */ "../components/Views/Admissions/KcseGrades"
                ),
        },
        // {
        //     path: "charges",
        //     name: "Admission Processing Charges",
        //     component: () =>
        //         import(
        //             /* webpackChunkName: 'admission-processing-charges' */ "../components/Views/Admissions/ProcessingCharges"
        //         ),
        // },

        {
            path: "past-papers",
            name: "Examination Past Papers",
            component: () =>
                import(
                        /* webpackChunkName: 'olevel-grades-list' */ "../components/Views/Admissions/PastPapers"
                ),
        },

        {
            path: "admission-acceptance-deadlines",
            name: "Admission Acceptance Deadlines",
            component: () =>
                import(
                        /* webpackChunkName: 'admission-acceptance-deadlines' */ "../components/Views/Admissions/AdmissionAcceptanceDeadlines"
                ),
        },

        {
            path: "admission-rounds",
            name: "Admissions Rounds",
            component: () =>
                import(
                        /* webpackChunkName: 'admissions-rounds-list' */ "../components/Views/Admissions/AdmissionRounds"
                ),
        },
        {
            path: "advertised-programmes-faculties",
            name: "Advertised Programmes Faculties",
            component: () =>
                import(/* webpackChunkName: 'advertised-programmes-faculties-list' */ "../components/Views/Admissions/Faculties.vue"),
        },
        {
            path: "advertised-programmes",
            name: "Advertised Programmes",
            props: true,
            component: () =>
                import(
                        /* webpackChunkName: 'advertised-programmes-list' */ "../components/Views/Admissions/AdvertisedProgrammes.vue"
                ),
        },
        {
            path: "admission-clearance-faculties",
            name: "Admission Clearance Faculties",
            component: () =>
                import(/* webpackChunkName: 'admissions-clearance-faculties-list' */ "../components/Views/Admissions/AdmissionClearanceFaculties"),
        },
        {
            path: "admission-clearance",
            name: "Admission Clearance",
            props: true,
            component: () =>
                import(
                        /* webpackChunkName: 'admission-clearance' */ "../components/Views/Admissions/ProgrammesWithAdmittedCandidates"
                ),
        },

        {
            path: "movement-list",
            component: () =>
                import(
                        /* webpackChunkName: 'movement-home' */ "../components/Views/Admissions/MovementHome"
                ),
            children: [
                {
                    path: "",
                    name: "Movement List",
                    component: () =>
                        import(
                                /* webpackChunkName: 'movement-list' */ "../components/Views/Admissions/MovementList"
                        ),
                },
                {
                    path: "to-be-moved",
                    name: "To Be Moved",
                    component: () =>
                        import(
                                /* webpackChunkName: 'to-be-moved-list' */ "../components/Views/Admissions/ToBeMovedList.vue"
                        ),
                },
                {
                    path: "pending-movement-list",
                    name: "Pending Movement List",
                    component: () =>
                        import(
                                /* webpackChunkName: 'pending-movement-list' */ "../components/Views/Admissions/PendingMovementList"
                        ),
                },
            ],
        },
        {
            path: "admission-agents",
            name: "Admission Agent",
            component: () =>
                import(
                        /* webpackChunkName: 'admission-agents-list' */ "../components/Views/Admissions/AdmissionAgentList"
                ),
        },

        // {
        //     path: "post-utme-exam/batch",
        //     name: "Post Utme Exam Batch",
        //     component: () =>
        //         import(
        //                 /* webpackChunkName: 'institutional-post-utme-exam-batch' */ "../components/Views/Admissions/PostUtmeExamBatch"
        //         ),
        //     props: true,
        // },

        {
            path: "requirements/general",
            name: "General Admission Requirements",
            component: () =>
                import(
                        /* webpackChunkName: 'institutional-general-admission-requirements' */ "../components/Views/Admissions/GeneralRequirements"
                ),
            props: true,
        },
        {
            path: "requirements/programme",
            name: "Programme Admission Requirements",
            component: () =>
                import(
                        /* webpackChunkName: 'programme-admission-requirements' */ "../components/Views/Admissions/ProgrammeRequirements"
                ),
            props: true,
        },
        {
            path: "programmes/candidates",
            name: "Programme Candidates",
            component: () =>
                import(
                        /* webpackChunkName: 'programme-candidates-list' */ "../components/Views/Admissions/ProgrammeCandidates"
                ),
            props: true,
        },

        {
            path: "clearance-candidates",
            name: "Clearance Candidates",
            component: () =>
                import(
                        /* webpackChunkName: 'clearance-candidates-list' */ "../components/Views/Admissions/ClearanceCandidates.vue"
                ),
            props: true,
        },

        {
            path: "programmes/candidates/application-details",
            name: "Candidate's Application Details",
            component: () =>
                import(
                        /* webpackChunkName: 'candidates-application-details' */ "../components/Views/Admissions/CandidateApplicationDetails"
                ),
            props: true,
        },

        {
            path: "clearance-candidates/clearance-documents",
            name: "Candidate's Clearance Documents",
            component: () =>
                import(
                        /* webpackChunkName: 'candidates-application-clearance-details' */ "../components/Views/Admissions/CandidateClearanceDocuments"
                ),
            props: true,
        },
        {
            path: 'candidate-approvals',
            component: () => import(/* webpackChunkName: 'admin-candidate-approvals' */ '../components/Views/Admin/AdmitCandidates/AdmitHome'),
            children: [
                {
                    path: '',
                    name: 'Manage Approved Candidates',
                    component: () => import( /* webpackChunkName: "admin-candidate-approvals-list" */ '../components/Views/Admin/AdmitCandidates/ApprovedCandidates'),
                },
                {
                    path: 'all-candidates',
                    name: 'Manage All Candidate Recommendations',
                    component: () => import( /* webpackChunkName: "admin-all-candidate-approvals-list" */ '../components/Views/Admin/AdmitCandidates/AllCandidates'),
                },
                {
                    path: "admissions-list",
                    name: 'Institute Upload Admission List',
                    component: () => import( /* webpackChunkName: 'admin-admissions-list' */ '../components/Views/Admin/AdmitCandidates/UploadAdmissionList'),
                },
            ]
        },
        {
            path: "admissions-list",
            name: 'Upload Admission List',
            component: () => import( /* webpackChunkName: 'admissions-list' */ '../components/Views/Admin/Admissions/UploadAdmissionList.vue'),
        },
    ],
    },

    { //-------------------routings to the curriculum management pages-----------------------//
        path: '/elections',
        name: 'Election Details',
        component: () => import( /* webpackChunkName: 'election-management' */ '../components/Views/Admin/Evoting/Dashboard'),
        meta: { authenticatedUserOnly: true },
        beforeEnter: checkSuperAdminRole,
        children: [
            {
                path: 'elections-dashboard',
                name: 'Election Dashboard',
                component: () => import( /* webpackChunkName: 'election-dashboard' */ '../components/Views/Admin/Evoting/DashboardOverview'),

            },

            {
                path: "management",
                name: "Election Management",
                component: () =>
                    import(
                        /* webpackChunkName: 'e-voting' */ "../components/Views/Admin/Evoting/Elections"
                    ),

            },

            {
                path: "management/student",
                name: "Student Election Management",
                component: () =>
                    import(
                        /* webpackChunkName: 'student-e-voting' */ "../components/Views/Admin/Evoting/StudentElections"
                    ),
            },
            {
                path: "management/staff",
                name: "Staff Election Management",
                component: () =>
                    import(
                        /* webpackChunkName: 'staff-e-voting' */ "../components/Views/Admin/Evoting/StaffElections"
                    ),
            },


            {
                path: "positions/:id",
                name: "Elective Positions",
                component: () =>
                    import(
                        /* webpackChunkName: 'elective-positions' */ "../components/Views/Admin/Evoting/ElectivePositions"
                    ),
                props: true,
                mode: "params",
            },
            {
                path: "position/contestants/:id",
                name: "Elective Position Details",
                component: () =>
                    import(
                        /* webpackChunkName: 'elective-position-contestants' */ "../components/Views/Admin/Evoting/ElectivePositionContestants"
                    ),
                props: true,
                mode: "params",
            },
            {
                path: "electorates/:id",
                name: 'Electorates',
                component: () => import( /* webpackChunkName: "electorates" */ '../components/Views/Admin/Evoting/Electorates'),
                props: true,
                mode: "params",
            },

            {
                path: "position/:id/votes",
                name: "Elective Position Votes",
                component: () =>
                    import(
                        /* webpackChunkName: 'elective-position-votes' */ "../components/Views/Admin/Evoting/Votes"
                    ),
                props: true,
                mode: "params",
            },

        ]
    },

{
    //-------------------routings to the users pages-----------------------//
    path: "/users",
    name: "Users Management",
    component: () =>
        import(
                /* webpackChunkName: 'user' */ "../components/Views/Admin/Users/Dashboard.vue"
        ),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkSuperAdminRole,
    children: [
        {
            path: "users-dashboard",
            name: "User Dashboard",
            component: () =>
                import(
                        /* webpackChunkName: 'user-home' */ "../components/Views/Admin/Users/Overview.vue"
                ),
        },

        {
            path: "users-management",
            component: () =>
                import(
                        /* webpackChunkName: 'users-management-home' */ "../components/Views/Admin/Users/UsersManagement"
                ),
            children: [
                {
                    path: "",
                    name: 'Manage Students',
                    component: () => import( /* webpackChunkName: "users-students" */ '../components/Views/Admin/Users/StudentManagement')
                },
                {
                    path: "lecturers",
                    name: 'Manage Lecturers',
                    component: () => import( /* webpackChunkName: "users-lecturers" */ '../components/Views/Admin/Users/LecturerManagement')
                },
                {
                    path: "supporting-staff",
                    name: 'Manage Supporting Staff',
                    component: () => import( /* webpackChunkName: "users-supporting-staff" */ '../components/Views/Admin/Users/SupportStaffManagement'),
                },
                {
                    path: "all-students",
                    name: 'Manage All Institution Students',
                    component: () => import( /* webpackChunkName: "all-students" */ '../components/Views/Admin/Users/AllStudentsManagement'),
                },
                {
                    path: "students-data",
                    name: 'Manage Active Institution Students Data',
                    component: () => import( /* webpackChunkName: "students-data" */ '../components/Views/Admin/Users/StudentDataManagement'),
                },
                {
                    path: 'student-results',
                    name: "Admin Student's Result",
                    component: () => import( /* webpackChunkName: 'users-students-results' */ '../components/Views/Admin/Users/StudentResults'),
                    props: true
                },
            ],
        },
]
},

//-------------------------------------

{
    //-------------------routings to the finance pages-----------------------//
    path: "/finance",
    name: "Finance",
    component: () =>
        import(
                /* webpackChunkName: 'finance' */ "../components/Views/Admin/Finance/Dashboard"
        ),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkSuperAdminRole,
    children: [
        {
            path: "finance-dashboard",
            name: "Finance Dashboard",
            component: () =>
                import(
                        /* webpackChunkName: 'finance-home' */ "../components/Views/Admin/Finance/FinanceOverview"
                ),
        },
        {
            path: "payments",
            name: "Payments",
            component: () =>
                import(
                        /* webpackChunkName: 'payments-lists' */ "../components/Views/Admin/Finance/Payments"
                ),
        },
        {
            path: "arrears-configurations",
            name: "Arrears Payment Configurations",
            component: () =>
                import(
                    /* webpackChunkName: 'arrears-configurations-lists' */ "../components/Views/Admin/Finance/ArrearsPaymentConfigurations"
                ),
        },
        {
            path: 'charges',
            name: "Admission Processing Charges",
            component: () => import( /* webpackChunkName: 'admission-processing-charges' */ '../components/Views/Admissions/ProcessingCharges'),
        },

        {
            path: "fees",
            //  name: "Fees",
            component: () => import( /* webpackChunkName: "fees" */ '../components/Views/Admin/Finance/FeesAndFeesAllocation'),
            //props: true,
            children: [
            // {
            //     path: "fee-items",
            //     name: 'Fee Items',
            //     component: () => import( /* webpackChunkName: "fee-items" */ '../components/Views/Admin/Finance/FeeItems')
            // },
            {
                path: "manage",
                // name: 'Manage Fee Item Groups / Fee Items',
                component: () => import( /* webpackChunkName: "manage-fee-items" */ '../components/Views/Admin/Finance/ManageFeeItemAndGroup'),
                children: [
                    {
                        path: "fee-items",
                        name: 'Fee Items',
                        component: () => import( /* webpackChunkName: "fee-items" */ '../components/Views/Admin/Finance/FeeItems')
                    },
                    {
                        path: "",
                        name: 'Fee Item Group',
                        component: () => import( /* webpackChunkName: "fee-heads" */ '../components/Views/Admin/Finance/FeeHeads')
                    },
                ]
            },
            {
                path: "fee-items-group",
                name: 'Fee Item Group Details',
                component: () => import( /* webpackChunkName: "fee-item-groupss" */ '../components/Views/Admin/Finance/FeeItemGroupDetails')
            },
            {
                path: "",
                name: 'Fee Plans',
                component: () => import( /* webpackChunkName: "fee-plans" */ '../components/Views/Admin/Finance/Feeplans')
            },
            {
                path: "fee-plan-allocation",
                name: 'Fee Plan Allocation',
                component: () => import( /* webpackChunkName: "fee-plan-allocation" */ '../components/Views/Admin/Finance/FeePlanAllocation')
            },
            ]
        },
        {
            path: "supplementary-fee",
            //  name: "Fees",
            component: () => import( /* webpackChunkName: "suplimentaty-fees" */ '../components/Views/Admin/Finance/SupplementaryFeesAndAllocation'),
            //props: true,
            children: [
            {
                path: "",
                name: 'Supplementary Fee',
                component: () => import( /* webpackChunkName: "suplimentary-fees" */ '../components/Views/Admin/Finance/SupplementaryFee')
            },
            {
                path: "allocations",
                name: 'Supplementary Fee Allocation',
                component: () => import( /* webpackChunkName: "supplimentary-fee-allocation" */ '../components/Views/Admin/Finance/SupplementaryFeeAllocation')
            },
            ]
        },
        {
            path: "rebates",
            component: () => import( /* webpackChunkName: "rebates-home" */ '../components/Views/Admin/Finance/Rebates/RebatesHome'),
            //props: true,
            children: [{
                path: "",
                name: 'Rebates',
                component: () => import( /* webpackChunkName: "rebates" */ '../components/Views/Admin/Finance/Rebates/RebatesComponent'),
            },
            {
                path: "rebates-grant",
                name: 'Rebates Grant',
                component: () => import( /* webpackChunkName: "rebates-grant" */ '../components/Views/Admin/Finance/Rebates/RebatesGrantComponent'),
            },

            {
                path: "scholarships",
                name: 'Scholarships',
                component: () => import( /* webpackChunkName: "scholarships" */ '../components/Views/Admin/Finance/Rebates/Scholarships'),
            },
            {
                path: "scholarship-grants",
                name: 'Scholarships Grant',
                component: () => import( /* webpackChunkName: "scholarship-grant" */ '../components/Views/Admin/Finance/Rebates/ScholarshipGrants'),
            },
            ]
        },
        {
            path: 'fee-plan-items',
            name: "Fee Plan Items",
            component: () => import( /* webpackChunkName: 'fee-plan-items' */ '../components/Views/Admin/Finance/FeePlanItems'),
            props: true,
        },
        {
            path: 'supplementary-fee/details',
            name: "Supplementary Fee Details",
            component: () => import( /* webpackChunkName: 'supplementary-fee-details' */ '../components/Views/Admin/Finance/SupplementaryFeeDetails'),
            props: true,
        },
        {
            path: "bank-accounts",
            name: "Bank Accounts",
            component: () =>
                import(
                        /* webpackChunkName: 'bank-accounts' */ "../components/Views/Admin/Finance/BankAccounts"
                ),
        },
        {
            path: 'transaction-validation',
            name: 'Students Transactions Validation',
            component: () => import(/* webpackChunkName: 'transaction-validation' */ '../components/Views/Admin/Finance/PaymentsValidation'),
        },

        {
            path: 'hostel-pool-charges',
            name: "Manage Hostel Pool",
            component: () => import( /* webpackChunkName: 'hostel-pool-charges' */ '../components/Views/Admin/Finance/HostelPoolCharges'),
        },

        {
            path: 'change-programme-charges',
            name: "Change of Programme Charges",
            component: () => import( /* webpackChunkName: 'change-programme-charges' */ '../components/Views/Admin/Finance/ChangeOfProgrammeCharges.vue'),
        },

        {
            path: 'convocation-charges',
            name: "Manage Convocation Charges",
            component: () => import( /* webpackChunkName: 'convocation-charges' */ '../components/Views/Admin/Finance/ConvocationCharges'),
        },

        {
            path: 'invoices',
            component: () => import( /* webpackChunkName: "invoice-management" */ '../components/Views/Admin/Finance/InvoiceManagement'),
            children: [

                {
                    path: "",
                    name: "Invoices",
                    component: () =>
                        import(
                                /* webpackChunkName: 'invoice-lists' */ "../components/Views/Admin/Finance/Invoices"
                        ),
                },
                {
                    path: 'invoice-gateways',
                    name: "Manage Invoice Gateways Fees",
                    component: () => import( /* webpackChunkName: 'invoice-gateways' */ '../components/Views/Admin/Finance/InvoiceGateway'),
                },
            ]
        },
        {
            path: 'service-charges',
            component: () => import( /* webpackChunkName: "service-charges" */ '../components/Views/Admin/Finance/ServiceCharges.vue'),
            children: [
                // {
                //     path: "",
                //     name: "Invoices",
                //     component: () =>
                //         import(
                //                 /* webpackChunkName: 'invoice-lists' */ "../components/Views/Admin/Finance/Invoices"
                //         ),
                // },
                {
                    path: 'invoice-gateways',
                    name: "Manage Invoice Gateways",
                    component: () => import( /* webpackChunkName: 'invoice-gateways' */ '../components/Views/Admin/Finance/InvoiceGateway'),
                },
            ]
        },
    ],
},
//------------------- candidate guarded routings -----------------
{
    path: "/candidate/admission/processing-charges",
    name: "Candidate Charges",
    component: () =>
        import(
                /* webpackChunkName: 'candidate-admission-processing-charges' */ "../components/Views/Candidate/Undergraduate/Fees/PreadmissionAppliactionProcessingCharges"
        ),
    props: true,
    // meta: { authenticatedUserOnly: true },
    //beforeEnter: checkCandidateRole,
},

{
    path: "/candidate/admission/processing-charges/private",
    name: "Private Candidate Charges",
    component: () =>
        import(
                /* webpackChunkName: 'private-candidate-admission-processing-charges' */ "../components/Views/Candidate/Undergraduate/Fees/PrivatePreadmissionAppliactionProcessingCharges"
        ),
    props: true,
},

{
    path: '/candidate',
    name: 'Candidate',
    component: () => import( /* webpackChunkName: 'candidate-dashboard' */ '../components/Views/Candidate/Dashboard'),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkCandidateRole,
    children: [

        //pg personal information
        {
            path: 'pg/application/:id',
            name: "Admission Application",
            component: () => import( /* webpackChunkName: 'admission-application' */ '../components/Views/Candidate/Postgraduate/Application'),

        },

        //ug personal information
        {
            path: 'utme-application',
            name: "UTME Application",
            component: () => import( /* webpackChunkName: 'utme-application' */ '../components/Views/Candidate/Undergraduate/UTMEApplication'),
        },

        {
            path: 'announcements',
            name: "Candidate Announcements",
            component: () => import( /* webpackChunkName: 'candidate-announcements' */ '../components/Views/Candidate/Announcements'),
        },

        {
            path: 'past-papers',
            name: "Examination Past Papers",
            component: () => import( /* webpackChunkName: 'candidate-announcements' */ '../components/Views/Candidate/PastPapers.vue'),
        },

        {
            path: 'admission/clearance-documents',
            name: "Clearance Documents",
            component: () => import( /* webpackChunkName: 'clearance-documents' */ '../components/Views/Candidate/Undergraduate/ClearanceDocuments'),
        },

        {
            path: 'bio-data',
            name: "Candidate Biodata",
            component: () => import( /* webpackChunkName: 'candidate-biodata' */ '../components/Views/Candidate/Undergraduate/BioData'),
            // props: true
        },
        {
            path: 'results/o-level',
            name: "Candidate OLevels",
            component: () => import( /* webpackChunkName: 'candidate-olevels' */ '../components/Views/Candidate/Undergraduate/Olevels'),
            // props: true
        },
        {
            path: 'admission-status',
            name: "Candidate Admission Status",
            component: () => import( /* webpackChunkName: 'candidate-admission-status' */ '../components/Views/Candidate/Undergraduate/AdmissionStatus'),
            // props: true
        },

        {
            path: 'admission/acceptance-fees',
            name: "candidate.payAdmissionAcceptanceFee",
            component: () => import( /* webpackChunkName: 'pay-admission-acceptance-fees' */ '../components/Views/Candidate/Undergraduate/Fees/PayAdmissionAcceptanceFee'),
        },


        {
            path: 'printouts',
            name: "Candidate Printouts",
            component: () => import( /* webpackChunkName: 'admission-application-printouts' */ '../components/Views/Candidate/PrintOuts'),

        },

        {
            path: 'migrate-to-student',
            name: "Migrate Candidate to Student",
            component: () => import( /* webpackChunkName: 'migrate-candidate-to-student' */ '../components/Views/Candidate/Undergraduate/MigrateCandidateToStudent'),

        },
    ],
},
{
    path: '*',
    name: 'Page Not Found',
    component: () => import( /* webpackChunkName: 'page-not-found' */ '../components/PageNotFound')
},

{ //-------------------routings to the hostel management pages-----------------------//
    path: '/hostel',
    name: 'Hostel',
    component: () => import( /* webpackChunkName: 'hostel' */ '../components/Views/Admin/HostelManagement/Dashboard'),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkSuperAdminRole,
    children: [

        {
            path: 'hostel-dashboard',
            name: 'Hostel Management Dashboard',
            component: () => import( /* webpackChunkName: 'hostel-dashboard' */ '../components/Views/Admin/HostelManagement/HostelOverview'),
        },
        {
            path: "hostels",
            //name: 'Manage Hostels And Hostel Blocks',
            component: () => import( /* webpackChunkName: "hostels-and-hostel-blocks" */ '../components/Views/Admin/HostelManagement/HostelsAndHostelBlocks'),
            //props: true,
            children: [{
                path: "",
                name: 'Manage Hostels',
                component: () => import( /* webpackChunkName: "manage-hostels" */ '../components/Views/Admin/HostelManagement/Hostels')
            },
            {
                path: "hostel-blocks",
                name: 'Manage Hostel Blocks',
                component: () => import( /* webpackChunkName: "hostel-blocks" */ '../components/Views/Admin/HostelManagement/HostelBlocks')
            },
            ]
        },
        {
            path: 'hostel-block-allocation',
            name: 'Hostel Block Allocations',
            component: () => import( /* webpackChunkName: 'hostel-block-allocation' */ '../components/Views/Admin/HostelManagement/HostelBlockAllocation'),

        },
        {
            path: "rooms",
            //name: 'Manage Hostel Rooms And Bedspaces',
            component: () => import( /* webpackChunkName: "hostel-rooms-and-bedspaces" */ '../components/Views/Admin/HostelManagement/RoomsAndBedspaces'),
            //props: true,
            children: [{
                path: "",
                name: 'Manage Hostel Rooms',
                component: () => import( /* webpackChunkName: "manage-rooms" */ '../components/Views/Admin/HostelManagement/Rooms')
            },
            {
                path: "bedspaces",
                name: 'Manage Bed Spaces',
                component: () => import( /* webpackChunkName: "hostel-bed-spaces" */ '../components/Views/Admin/HostelManagement/BedSpaces')
            },
            ]
        },

        {
            path: "reservation-and-allocations",
            //name: 'Manage Reservations And Allocations',
            component: () => import( /* webpackChunkName: "bedspace-reservation-and-allocations" */ '../components/Views/Admin/HostelManagement/BedSpaceReservationsAndAllocations'),
            //props: true,
            children: [{
                path: "",
                name: 'Manage Bedspace Allocations',
                component: () => import( /* webpackChunkName: "manage-bed-space-allocations" */ '../components/Views/Admin/HostelManagement/Reservations')
            },
            {
                path: "allocations",
                name: 'Manage Allocations',
                component: () => import( /* webpackChunkName: "allocations" */ '../components/Views/Admin/HostelManagement/Allocations')
            },
            ]
        },

        {
            path: "hostel-balloting-schedule",
            name: 'Hostel Balloting Schedule',
            component: () => import( /* webpackChunkName: "hostel-balloting-schedule" */ '../components/Views/Admin/HostelManagement/HostelBallotingSchedule')
        },

        {
            path: "manual-reservation",
            name: 'Manual Reservation',
            component: () => import( /* webpackChunkName: "manual-hostel-reservation" */ '../components/Views/Admin/HostelManagement/ManualReservation')
        },

        {
            path: "manual-allocation",
            name: 'Manual Allocation',
            component: () => import( /* webpackChunkName: "manual-hostel-allocation" */ '../components/Views/Admin/HostelManagement/ManualAllocation')
        },

    ]
},

//-----------------------------------------routings for role switching -------------------//
{
    path: '/switch-role',
    name: 'Switch Role',
    component: () => import(/* webpackChunkName: "switch-role" */ '../components/SwitchRole'),
    meta: { authenticatedUserOnly: true },
},


//-----------------------------------------routings for private institutions-------------------//
{
    path: '/applicant/:acronym?',
    name: 'Applicant',
    component: () => import(/* webpackChunkName: "ug-applicant-login" */ '../components/Views/Candidate/Undergraduate/PrivateInstitutions/Login'),
    meta: { guestUserOnly: true }
},
{
    path: '/open-application',
    name: 'Open Application',
    component: () => import(/* webpackChunkName: "ug-applicant-login" */ '../components/Views/Candidate/Undergraduate/PrivateInstitutions/OpenApplicationLogin'),
    meta: { guestUserOnly: true }
},
{
    path: '/ug/inter-university-transfer',
    name: 'Inter University Transfer',
    component: () => import(/* webpackChunkName: "ug-inter-university-transfer" */ '../components/Views/Candidate/Undergraduate/InterUniversityLogin'),
    meta: { guestUserOnly: true }
},
{
    path: '/ug/inter-university-transfer/enroll',
    name: 'Inter University Enroll',
    component: () => import( /* webpackChunkName: "ug-inter-university-transfer-enrollment" */ '../components/Views/Candidate/Undergraduate/InterUniversityEnroll'),
    meta: { guestUserOnly: true }
},
{
    path: '/ug/international-admission',
    name: 'International Admissions',
    component: () => import(/* webpackChunkName: "ug-international-admission" */ '../components/Views/Candidate/Undergraduate/InternationAdmissionLogin'),
    meta: { guestUserOnly: true }
},
{
    path: '/ug/international-admission/enroll',
    name: 'International Admissions Enroll',
    component: () => import( /* webpackChunkName: "ug-international-admission-enrollment" */ '../components/Views/Candidate/Undergraduate/InternationAdmissionEnroll'),
    meta: { guestUserOnly: true }
},
{
    path: '/ug/applicant/enroll',
    name: 'Applicant Enroll',
    component: () => import( /* webpackChunkName: "ug-applicant-enrollment" */ '../components/Views/Candidate/Undergraduate/PrivateInstitutions/Enroll'),
    meta: { guestUserOnly: true }
},
{
    path: '/open-application/enroll',
    name: 'Open Application Enroll',
    component: () => import( /* webpackChunkName: "ug-applicant-enrollment" */ '../components/Views/Candidate/Undergraduate/PrivateInstitutions/OpenApplicationEnroll'),
    meta: { guestUserOnly: true }
},
{
    path: '/ug/applicant/email/activate',
    name: 'Applicant Email Verification',
    component: () => import( /* webpackChunkName: "applicant-email-verification" */ '../components/Views/Candidate/Undergraduate/PrivateInstitutions/EmailVerification'),
    meta: { guestUserOnly: true }
},

{
    path: '/ug/applicant/email/activated',
    name: 'Applicant Email Verified',
    component: () => import( /* webpackChunkName: "candidate-activated" */ '../components/Views/Candidate/Undergraduate/PrivateInstitutions/CandidateAccountActivated'),
    props: route => ({
        email: route.params.email,
        phone: route.params.phone,
        institution: route.params.institution
    }),
    meta: { guestUserOnly: true }
},
{
    path: '/direct-candidate',
    name: 'Private Candidate Application',
    component: () => import( /* webpackChunkName: 'direct-candidate-dashboard' */ '../components/Views/Candidate/Undergraduate/PrivateInstitutions/Dashboard'),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkCandidateRole,
    children: [

        {
            path: 'private/application',
            name: "Direct Candidate Application",
            component: () => import( /* webpackChunkName: 'direct-candidate-application' */ '../components/Views/Candidate/Undergraduate/PrivateInstitutions/Application'),
        },

        {
            path: 'utme/application',
            name: "UTME Candidate Application",
            component: () => import( /* webpackChunkName: 'utme-application' */ '../components/Views/Candidate/Undergraduate/UTMEApplication'),
        },

        {
            path: 'announcements',
            name: "Candidate's Announcements",
            component: () => import( /* webpackChunkName: 'candidate-announcements' */ '../components/Views/Candidate/Announcements'),
        },
        {
            path: 'past-papers',
            name: "Examination Past Papers",
            component: () => import( /* webpackChunkName: 'candidate-announcements' */ '../components/Views/Candidate/PastPapers.vue'),
        },

        {
            path: 'admission/clearance-documents',
            name: "Candidate Clearance Documents",
            component: () => import( /* webpackChunkName: 'clearance-documents' */ '../components/Views/Candidate/Undergraduate/ClearanceDocuments'),
        },

        {
            path: 'bio-data',
            name: "Candidate Bio-data",
            component: () => import( /* webpackChunkName: 'candidate-biodata' */ '../components/Views/Candidate/Undergraduate/BioData'),
            // props: true
        },
        {
            path: 'results/o-level',
            name: "Candidate Olevels",
            component: () => import( /* webpackChunkName: 'candidate-olevels' */ '../components/Views/Candidate/Undergraduate/Olevels'),
            // props: true
        },
        {
            path: 'admission/status',
            name: "Private Candidate Admission Status",
            component: () => import( /* webpackChunkName: 'direct-candidate-admission-status' */ '../components/Views/Candidate/Undergraduate/AdmissionStatus'),
            // props: true
        },

        {
            path: 'admission/acceptance-fees',
            name: "private.candidate.payAdmissionAcceptanceFee",
            component: () => import( /* webpackChunkName: 'pay-admission-acceptance-fees-direct-candidate' */ '../components/Views/Candidate/Undergraduate/Fees/PayAdmissionAcceptanceFee'),
        },


        {
            path: 'printouts',
            name: "Candidate Application Printouts",
            component: () => import( /* webpackChunkName: 'admission-application-printouts' */ '../components/Views/Candidate/PrintOuts'),

        },

        {
            path: 'migrate-to-student',
            name: "Migrate candidate to student",
            component: () => import( /* webpackChunkName: 'migrate-candidate-to-student' */ '../components/Views/Candidate/Undergraduate/MigrateCandidateToStudent'),

        },

    ],
},

{ //-------------------routings to the curriculum management pages-----------------------//
    path: '/curriculum',
    name: 'Admin Curriculum',
    component: () => import( /* webpackChunkName: 'admin-curriculum' */ '../components/Views/Admin/CurriculumManagement/Dashboard'),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkSuperAdminRole,
    children: [

        {
            path: 'curriculum-dashboard',
            name: 'Curriculum Management Dashboard',
            component: () => import( /* webpackChunkName: 'curriculum-dashboard' */ '../components/Views/Admin/CurriculumManagement/CurriculumOverview'),
        },
        {
            path: "curriculum-management",
            name: 'Manage Curriculums',
            component: () => import( /* webpackChunkName: "curriculum-management" */ '../components/Views/Admin/CurriculumManagement/CurriculumManagement'),
        },
        {
            path: "/manage/:id",
            name: "Curriculum Management Admin",
            component: () =>
                import(
                    /* webpackChunkName: 'manage' */ "../components/Views/Department/Curriculum/CurriculumManagement"
                ),
            props: true,
            mode: "params",
        },
        {
            path: "curriculums-allocations",
            name: 'Curriculum Allocations Admin',
            component: () => import( /* webpackChunkName: "curriculums-allocations" */ '../components/Views/Admin/CurriculumManagement/CurriculumAllocations'),
        },
    ]
},

{ //-------------------routings to the cordinator offices------//beforeEnter: checkHODRole,-------------------//
    path: '/programme-cordinator',
    name: 'Programme Cordinator Dashboard',
    component: ProgrammeCordinatorDashboard,
    beforeEnter: checkProgrammeCordinatorRole,
    meta: { authenticatedUserOnly: true },
    children: [{
        path: 'overview',
        name: 'Programme Cordinator Home',
        component: () => import( /* webpackChunkName: 'cordinator-home' */ '../components/Views/ProgrammeCordinator/Overview')
    },
    {
        path: 'staff',
        name: 'Programme Cordinator Staff Members',
        component: () => import( /* webpackChunkName: 'cordinator-staff-list' */ '../components/Views/ProgrammeCordinator/Staff')
    },
    {
        path: 'programmes',
        name: 'Programme Cordinator Programmes',
        component: () => import( /* webpackChunkName: 'cordinator-programmes-list' */ "../components/Views/ProgrammeCordinator/Programmes")
    },
    {
        path: 'transfer-requests',
        name: 'Programme Cordinator Transfer Requests',
        component: () => import(/* webpackChunkName: 'cordinator-transfer-requests' */ '../components/Views/ProgrammeCordinator/Transfers/TransferHome'),
        children: [{
            path: "inbound",
            name: 'Programme Cordinator Inbound Transfer Requests',
            component: () => import( /* webpackChunkName: "cordinator-inbound-transfer-requests" */ '../components/Views/ProgrammeCordinator/Transfers/InboundTransfer'),
        },
        {
            path: "outbound",
            name: 'Programme Cordinator Outbound Transfer Requests',
            component: () => import( /* webpackChunkName: "cordinator-outbound-teransfer-requests" */ '../components/Views/ProgrammeCordinator/Transfers/OutboundTransfer'),
        },

        ]
    },
    {
        path: 'courses',
        name: 'Programme Cordinator Courses',
        component: () => import( /* webpackChunkName: 'cordinator-courses' */ "../components/Views/ProgrammeCordinator/Courses")
    },
    {
        path: 'course-allocations',
        name: 'Programme Cordinator Course Allocations',
        component: () => import( /* webpackChunkName: 'cordinator-course-allocation' */ '../components/Views/ProgrammeCordinator/CourseAllocations')
    },
    {
        path: 'academic-advisers',
        name: 'Programme Cordinator Academic Level Advisers',
        component: () => import( /* webpackChunkName: 'cordinator-academic-advisers' */ '../components/Views/ProgrammeCordinator/LevelAdvisers')
    },
    {
        path: 'appoint-exam-officer',
        name: 'Programme Cordinator Appoint Exam Officer',
        component: () => import( /* webpackChunkName: 'cordinator-appoint-exam-officer' */ '../components/Views/ProgrammeCordinator/AppointExamOfficer')
    },
    {
        path: 'students',
        name: 'Programme Cordinator Students',
        component: () => import( /* webpackChunkName: 'cordinator-students-list' */ '../components/Views/ProgrammeCordinator/Students')
    },
    {
        path: 'students-results',
        name: 'Programme Cordinator Students Results',
        component: () => import( /* webpackChunkName: 'cordinator-students-results-list' */ '../components/Views/ProgrammeCordinator/MyStudentResults')
    },
    {
        path: 'student-results/result',
        name: "Programme Cordinator Student's Result",
        component: () => import( /* webpackChunkName: 'cordinator-students-results' */ '../components/Views/ProgrammeCordinator/StudentResults'),
        props: true
    },
    {
        path: "assessment-score",
        name: 'Programme Cordinator Upload Assessment Score',
        component: () => import( /* webpackChunkName: "cordinator-assessment-score" */ '../components/Views/ProgrammeCordinator/AssessmentScore'),
    },
    {
        path: 'course-publications',
        name: 'Programme Cordinator Course Publications',
        component: () => import( /* webpackChunkName: 'cordinator-course-publication' */ '../components/Views/ProgrammeCordinator/CoursePublications')
    },
    {
        path: 'students-registration-list',
        component: () => import( /* webpackChunkName: "cordinator-students-registration-list-home" */ '../components/Views/ProgrammeCordinator/StudentsRegistrationList/StudentsRegistration'),
        children: [
            {
                path: '',
                name: 'Programme Cordinator View Registration Submission List',
                component: () => import( /* webpackChunkName: "cordinator-students-registration-submission-list" */ '../components/Views/ProgrammeCordinator/StudentsRegistrationList/StudentsRegistrationSubmissionList')
            },
            {
                path: 'enrollment-list',
                name: 'Programme Cordinator View Course Enrollment List',
                component: () => import( /* webpackChunkName: "cordinator-students-courses-enrollment-list" */ '../components/Views/ProgrammeCordinator/StudentsRegistrationList/StudentsCoursesEnrollmentList')
            },
        ]
    },
    {
        path: 'course-registrations',
        name: 'Programme Cordinator Course Registrations',
        component: () => import( /* webpackChunkName: 'cordinator-course-registrations' */ '../components/Views/ProgrammeCordinator/CoursesRegistrations')
    },
    {
        path: "students-course-reg/documents",
        name: "Programme Cordinator Student's Course Registration Documents",
        component: () =>
            import(
                /* webpackChunkName: 'cordinator-students-course-registration-documents' */ "../components/Views/ProgrammeCordinator/StudentCourseRegistrationDocuments"
            ),
        props: true,
    },
    {
        path: 'extra-credit-applications',
        name: 'Programme Cordinator Extra Credit Applications',
        component: () => import( /* webpackChunkName: 'cordinator-extra-credit-applications' */ '../components/Views/ProgrammeCordinator/ExtraCreditApplications')
    },
    {
        path: "course-specifications",
        name: "Programme Cordinator Course Specifications ",
        component: () =>import( /* webpackChunkName: 'cordinator-course-specifications' */ "../components/Views/ProgrammeCordinator/CourseSpecification"
            ),
    },
    {
        path: 'departmental-progression',
        name: 'Programme Cordinator Students Progresion',
        component: () => import( /* webpackChunkName: 'cordinator-progression' */ '../components/Views/ProgrammeCordinator/StudentProgression')
    },

    {
        path: 'graduation-management',
        component: () => import( /* webpackChunkName: "coordinator-graduation-management" */ '../components/Views/ProgrammeCordinator/GraduationList/GraduationManagement'),
        children: [

            {
                path: "list",
                name: 'Programme Cordinator Graduation List Cordinator Panel',
                component: () => import( /* webpackChunkName: "cordinator-graduation-list" */ '../components/Views/ProgrammeCordinator/GraduationList/GraduationList'),
            },
            {
                path: "graduated-students",
                name: 'Programme Cordinator Graduated Students Cordinator Panel',
                component: () => import(/* webpackChunkName: 'coordinator-graduated-students' */ '../components/Views/ProgrammeCordinator/GraduationList/GraduatedStudentsList'),
            }
        ]
    },

    {
        path: "good-standing-management",
        name: 'Programme Cordinator Good Standing List',
        component: () => import( /* webpackChunkName: "cordinator-good-standing-management" */ '../components/Views/ProgrammeCordinator/GoodStandingList'),
    },

    {
        path: 'progression',
        name: 'Programme Cordinator Students Progresion',
        component: () => import( /* webpackChunkName: 'cordinator-progression' */ '../components/Views/ProgrammeCordinator/StudentProgression')
    },

    ]
},

{
    path: '/siwes/statistics',
    name: 'SIWES Statistics',
    component: () => import(/* webpackChunkName: 'siwes-statistics' */ '../components/Views/Admin/Siwes/SiwesStatistics.vue'),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkSuperAdminRole,
},

{
    path: '/siwes',
    name: 'SIWES Admin',
    component: () => import(/* webpackChunkName: 'siwes-admin' */ '../components/Views/Admin/Siwes/SiwesAdminDashboard.vue'),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkSuperAdminRole,
    children: [
        {
            path: 'dashboard',
            name: 'SIWES Admin Dashboard',
            component: () => import(/* webpackChunkName: 'siwes-admin-home' */ '../components/Views/Admin/Siwes/SiwesAdminOverview.vue'),
        },
        {
            path: '',
            name: 'SIWES Admin Dashboard (Default)',
            component: () => import(/* webpackChunkName: 'siwes-admin-home' */ '../components/Views/Admin/Siwes/SiwesAdminOverview.vue'),
        },
        {
            path: "assessments",
            name: 'SIWES Admin Assessments',
            component: () => import(/* webpackChunkName: 'siwes-assessments' */ '../components/Views/Admin/Siwes/SiwesAssessment.vue'),
        },
        {
            path: "assessments/:id",
            name: 'SIWES Admin Assessment Detail',
            component: () => import(/* webpackChunkName: 'siwes-assessment-detail' */ '../components/Views/Admin/Siwes/SiwesAssessment.vue'),
            props: true,
        },
        {
            path: "forms",
            name: 'SIWES Admin Forms',
            component: () => import(/* webpackChunkName: 'siwes-forms' */ '../components/Views/Admin/Siwes/SiwesForm.vue'),
        },
        {
            path: "forms/:id",
            name: 'SIWES Admin Form Detail',
            component: () => import(/* webpackChunkName: 'siwes-form-detail' */ '../components/Views/Admin/Siwes/SiwesForm.vue'),
            props: true,
        },
        {
            path: "questions",
            name: 'SIWES Admin Questions',
            component: () => import(/* webpackChunkName: 'siwes-questions' */ '../components/Views/Admin/Siwes/SiwesQuestion.vue'),
        },
        {
            path: "questions/:id",
            name: 'SIWES Admin Question Detail',
            component: () => import(/* webpackChunkName: 'siwes-question-detail' */ '../components/Views/Admin/Siwes/SiwesQuestion.vue'),
            props: true,
        },
        {
            path: "evaluations",
            name: 'SIWES Admin Evaluations',
            component: () => import(/* webpackChunkName: 'siwes-evaluations' */ '../components/Views/Admin/Siwes/SiwesEvaluation.vue'),
        },
        {
            path: "evaluations/:id",
            name: 'SIWES Admin Evaluation Detail',
            component: () => import(/* webpackChunkName: 'siwes-evaluation-detail' */ '../components/Views/Admin/Siwes/SiwesEvaluation.vue'),
            props: true,
        },
        {
            path: "placements",
            name: 'SIWES Admin Placements',
            component: () => import(/* webpackChunkName: 'siwes-placements' */ '../components/Views/Admin/Siwes/SiwesPlacement.vue'),
        },
        {
            path: "placements/:id",
            name: 'SIWES Admin Placement Detail',
            component: () => import(/* webpackChunkName: 'siwes-placement-detail' */ '../components/Views/Admin/Siwes/SiwesPlacement.vue'),
            props: true,
        },
        {
            path: "assessment-forms",
            name: 'SIWES Admin Assessment Forms',
            component: () => import(/* webpackChunkName: 'siwes-assessment-forms' */ '../components/Views/Admin/Siwes/SiwesAssessmentForm.vue'),
        },
        {
            path: "assessment-forms/:id",
            name: 'SIWES Admin Assessment Form Detail',
            component: () => import(/* webpackChunkName: 'siwes-assessment-form-detail' */ '../components/Views/Admin/Siwes/SiwesAssessmentForm.vue'),
            props: true,
        },
        {
            path: "reports",
            name: 'SIWES Admin Reports',
            component: () => import(/* webpackChunkName: 'siwes-reports' */ '../components/Views/Admin/Siwes/SiwesReports.vue'),
        },
        {
            path: "statistics",
            name: 'SIWES Admin Statistics',
            component: () => import(/* webpackChunkName: 'siwes-statistics' */ '../components/Views/Admin/Siwes/SiwesStatistics.vue'),
        },
    ]
},

{
    path: '/lecturer-assessment',
    name: 'Lecturer Assessment',
    component: () => import(/* webpackChunkName: 'lecturer-assessment' */ '../components/Views/Admin/LecturerAssessment/Dashboard'),
    meta: { authenticatedUserOnly: true },
    beforeEnter: checkSuperAdminRole,
    children: [
        {
            path: 'dashboard',
            name: 'Lecturer Assessment Dashboard',
            component: () => import(/* webpackChunkName: 'lecturer-assessment-home' */ '../components/Views/Admin/LecturerAssessment/LecturerAssessmentOverview'),
        },
      {
        path: '',
        name: 'Lecturer Assessment Add Question (Default)',
        component: () => import(/* webpackChunkName: 'lecturer-assessment-add-question' */ '../components/Views/Admin/LecturerAssessment/AddQuestion'),
      },
      {
        path: "add-question",
        name: 'Lecturer Assessment Add Question',
        component: () => import(/* webpackChunkName: 'lecturer-assessment-add-question' */ '../components/Views/Admin/LecturerAssessment/AddQuestion'),
      },
      {
        path: "questionnaire-question",
        name: 'Lecturer Assessment Add Questionnaire Question',
        component: () => import(/* webpackChunkName: 'lecturer-assessment-questionnaire-question' */ '../components/Views/Admin/LecturerAssessment/QuestionnaireQuestion'),
      },
      {
        path: "questionnaire",
        name: 'Lecturer Assessment Add Questionnaire',
        component: () => import(/* webpackChunkName: 'lecturer-assessment-questionnaire' */ '../components/Views/Admin/LecturerAssessment/Questionnaire'),
      },
      {
        path: "questionnaire-allocation",
        name: 'Lecturer Assessment Add Questionnaire Allocation',
        component: () => import(/* webpackChunkName: 'lecturer-assessment-questionnaire-allocation' */ '../components/Views/Admin/LecturerAssessment/QuestionnaireAllocation'),
      },
      {
        path: "questionnaire-allocation/response/:allocation_id",
        name: 'Lecturer Assessment Response',
        component: () => import(/* webpackChunkName: 'lecturer-assessment-questionnaire-response' */ '../components/Views/Admin/LecturerAssessment/QuestionnaireResponse'),
      },
    ]
},

];

const router = new VueRouter({
    routes,
    mode: "history",
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.authenticatedUserOnly)) {
        // if user is logged in, allow access
        // else redirect to login
        AuthUser.authCheck()
            .then(() => {
                next();
            })
            .catch(() => {
                next("/login");
            });
        // next();
    } else if (to.matched.some((record) => record.meta.guestUserOnly)) {
        // if user is logged in, restrict access
        // only for guests
        AuthUser.authCheck()
            .then((response) => {
                let primaryRole = response.data.data.roles[0]; //  || primaryRole.name === "Staff"
                let primaryRoleName =
                    primaryRole.type === "Admin"
                        ? "Admin"
                        : primaryRole.name;
                primaryRoleName = primaryRoleName.trim();

                let nextPath = "";
                switch (primaryRoleName) {
                    case "Admin":
                    case "Super Admin":
                        nextPath = "/admin"
                        break;
                    case "Lecturer":
                        nextPath = "/lecturer"
                        break;
                    case "Staff":
                        nextPath = "/staff"
                        break;
                    case "Student":
                        nextPath = "/student"
                        break;
                    case "Candidate":
                        nextPath = "/candidate"
                        break;
                    default:
                        nextPath = "/"
                }
                next(nextPath);
            }).catch(() => {
                next();
            });
    } else {
        next(); // make sure to always call next()!
    }
});

router.beforeEach((to, from, next) => {
    if (to.path.startsWith('/student/')) {
        const hasPaid = sessionStorage.getItem('access-state')?? true;
        if (!hasPaid) {
            return next('/student');
        }
    }
    next();
});

// Suppress NavigationDuplicated errors
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

function checkSuperAdminRole(to, from, next) {
    UserAPI.auth()
        .then(response => {
            // if (response.data.data.usertype === 'Admin') {
            if (roleNamesContain(response.data.data.roles, 'Admin')
                || roleNamesContain(response.data.data.roles, 'Super Admin')
                // || roleNamesContain(response.data.data.roles, 'Staff')
                || hasAdminRole(response.data.data.roles)) {
                next();
            } else {
                next({
                    path: "/no-access",
                    query: { redirect: to.fullPath },
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

function checkSuperAdminOrDirectorRole(to, from, next) {
    UserAPI.auth()
        .then(response => {
            // if (response.data.data.usertype === 'Admin') {
            if (roleNamesContain(response.data.data.roles, 'Admin')
                || roleNamesContain(response.data.data.roles, 'Super Admin')
                || roleNamesContain(response.data.data.roles, 'Director')
                || roleNamesContain(response.data.data.roles, 'Deputy Director')
                || hasAdminRole(response.data.data.roles)) {
                next();
            } else {
                next({
                    path: "/no-access",
                    query: { redirect: to.fullPath },
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}


function checkLecturerRole(to, from, next) {
    UserAPI.auth()
        .then((response) => {
            if (roleNamesContain(response.data.data.roles, "Lecturer")) {
                next();
            } else {
                next({
                    path: "/no-access",
                    query: { redirect: to.fullPath },
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

function checkStaffRole(to, from, next) {
    UserAPI.auth()
        .then((response) => {
            if (roleNamesContain(response.data.data.roles, "Staff")) {
                next();
            } else {
                next({
                    path: "/no-access",
                    query: { redirect: to.fullPath },
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

function checkHODRole(to, from, next) {
    UserAPI.auth()
        .then(response => {
            if (roleNamesContain(response.data.data.roles, 'HOD')) {
                next();
            } else {
                next({
                    path: '/no-access',
                    query: { redirect: to.fullPath }
                });
            }
        })
        .catch(error => {
            console.log(error);
        });
}

function checkCordinatorRole(to, from, next) {
    UserAPI.auth()
        .then(response => {
            if (roleNamesContain(response.data.data.roles, 'Cordinator')) {
                next();
            } else {
                next({
                    path: '/no-access',
                    query: { redirect: to.fullPath }
                });
            }
        })
        .catch(error => {
            console.log(error);
        });
}

function checkProgrammeCordinatorRole(to, from, next) {
    UserAPI.auth()
        .then(response => {
            if (roleNamesContain(response.data.data.roles, 'Programme Cordinator')) {
                next();
            } else {
                next({
                    path: '/no-access',
                    query: { redirect: to.fullPath }
                });
            }
        })
        .catch(error => {
            console.log(error);
        });
}

function checkDirectorRole(to, from, next) {
    UserAPI.auth()
        .then(response => {
            if (roleNamesContain(response.data.data.roles, 'Director')) {
                next();
            } else {
                next({
                    path: '/no-access',
                    query: { redirect: to.fullPath }
                });
            }
        })
        .catch(error => {
            console.log(error);
        });
}

function checkRole(to, from, next) {
    UserAPI.auth()
        .then(response => {
            if (roleNamesContain(response.data.data.roles, 'Dean of Faculty')) {
                next();
            }

            else if (roleNamesContain(response.data.data.roles, 'Deputy Dean')) {
                next();
            }
            else {
                next({
                    path: '/no-access',
                    query: { redirect: to.fullPath }
                });
            }
        })
        .catch(error => {
            console.log(error);
        });
}

function checkFacultyExamOfficerRole(to, from, next) {
    UserAPI.auth()
        .then(response => {
            if (roleNamesContain(response.data.data.roles, 'Faculty Exam Officer')) {
                next();
            }
            else {
                next({
                    path: '/no-access',
                    query: { redirect: to.fullPath }
                });
            }
        })
        .catch(error => {
            console.log(error);
        });
}

function checkAdministrativeOfficerRole(to, from, next) {
    UserAPI.auth()
        .then(response => {
            if (roleNamesContain(response.data.data.roles, 'Faculty Officer')) {
                next();
            }
            else {
                next({
                    path: '/no-access',
                    query: { redirect: to.fullPath }
                });
            }
        })
        .catch(error => {
            console.log(error);
        });
}

function checkFinanceOfficerRole(to, from, next) {
    UserAPI.auth()
        .then(response => {
            if (roleNamesContain(response.data.data.roles, 'Faculty Accountant')) {
                next();
            }
            else {
                next({
                    path: '/no-access',
                    query: { redirect: to.fullPath }
                });
            }
        })
        .catch(error => {
            console.log(error);
        });
}

function checkHostelManagerRole(to, from, next) {
    UserAPI.auth()
        .then(response => {
            if (roleNamesContain(response.data.data.roles, 'Hostel Manager')) {
                next();
            }
            else {
                next({
                    path: '/no-access',
                    query: { redirect: to.fullPath }
                });
            }
        })
        .catch(error => {
            console.log(error);
        });
}

function checkDepartmentExamOfficerRole(to, from, next) {
    UserAPI.auth()
        .then(response => {
            if (roleNamesContain(response.data.data.roles, 'Department Exam Officer')) {
                next();
            }
            else {
                next({
                    path: '/no-access',
                    query: { redirect: to.fullPath }
                });
            }
        })
        .catch(error => {
            console.log(error);
        });
}

function checkLevelAdviserRole(to, from, next) {
    UserAPI.auth()
        .then(response => {
            if (roleNamesContain(response.data.data.roles, 'Level Adviser')) {
                next();
            } else {
                next({
                    path: '/no-access',
                    query: { redirect: to.fullPath }
                });
            }
        })
        .catch(error => {
            console.log(error);
        });
}

function checkStudentRole(to, from, next) {
    UserAPI.auth()
        .then((response) => {
            if (roleNamesContain(response.data.data.roles, "Student")) {
                next();
            } else {
                next({
                    path: "/no-access",
                    query: { redirect: to.fullPath },
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

function checkCandidateRole(to, from, next) {
    UserAPI.auth()
        .then((response) => {
            if (roleNamesContain(response.data.data.roles, "Candidate")) {
                next();
            } else {
                next({
                    path: "/no-access",
                    query: { redirect: to.fullPath },
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

function checkAdmissionsDashboardPermission(to, from, next) {
   // UserAPI.getMyRolesAndPermissions([])
   UserAPI.auth()
        .then(response => {
            let roles = response.data.data.role_names;
            let permissions = response.data.data.permission_names;

            if (hasAllPermissionsTo(permissions, ['view admissions dashboard'])
                || permissions.find(permission => permission === 'clear admitted candidates')
                || roles.find(role => role === 'Admin')
                || roles.find(role => role === 'Super Admin')
            ) {
                next();
            } else {
                next({
                    path: "/no-access",
                    query: { redirect: to.fullPath },
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}


function roleNamesContain(roleList, roleName) {
    return roleList.find(role => role.name === roleName) ? true : false;
}

function hasAdminRole(roleList) {
    return roleList.find(role => role.type === "Admin") ? true : false;
}

function hasAllPermissionsTo(userPermissions, requiredPermissions) {
    //function to check if all the elements of an array are present in another array
    if (0 === requiredPermissions.length) {
        return false;
    }
    return requiredPermissions.every(function (value) {
        return userPermissions.indexOf(value) >= 0;
    });
}

function enforceRequestParameter(to, from, next) {
    // Check if the "id" parameter is present in the route
    if (to.query.id) {
        next(); // Proceed to the route if the "id" parameter exists
    } else {
        // Redirect to the "Not Found" component if "id" is missing
        next({
            path: "/no-access",
            query: { redirect: to.fullPath },
        });
    }
}

export default router;
